export default {
    // 中
    zhCN: {
        documentType: '单据类型',
        vehicleType: '车辆类型',
        dealerInformation: '经销商信息',
        reportType: '上报类型',
        dealerContact: '经销商联系人',
        contact: '联系电话',
        customer_information: '客户信息',
        occupation: '职业',
        vehicleInformation: '车辆信息',
        mileage: '行驶里程/km',
        licensePlate: '车牌号',
        platform: '车型平台',
        offLineDate: '下线日期',
        vehicleUse: '车辆用途',
        refited: '是否有加改装',
        insuranceSituation: '保险情况',
        nameplateNo: '铭牌编号',
        purchaseDate: '购买日期',
        accidentInformation: '事故信息',
        timeOfAccident: '事故发生时间',
        placeOfAccident: '事故发生地点',
        roadConditions: '道路状况',
        pavementType: '路面类型',
        weather: '天气',
        vehicleCondition: '车辆状况',
        vehicleOfTheAccident: '事故发生时车辆信息',
        vehicleCollisionPosition: '车辆碰撞位置',
        vehicleRunningStatus: '车辆行驶状态',
        ownSpeed: '己方车速',
        vehicleSpeedOfTheOtherSide: '对方车速',
        personnelInsideTheVehicle: '事发车内人员情况',
        numberOfPeopleInTheCar: '车内人数',
        personalInjury: '人员受伤情况',
        distributionOfPersonnelInTheVehicle: '受伤人员所坐位置',
        descriptionOfPersonalInjury: '人员受伤情况描述',
        airbagDeployment: '气囊展开情况',
        safetyBeltWearing: '安全带佩戴情况',
        brakeBeforeTheAccident: '事发前刹车',
        turnBeforeTheIncident: '事发前转向',
        whenCorrosionOccurs: '何时发生腐蚀',
        parkingTimeHours: '停车时间（小时）',
        parkingTimeMinutes: '停车时间（分钟）',
        drivingHours: '驾驶小时',
        drivingMinutes: '驾驶分钟',
        drivingDistance: '驾驶距离',
        drivingSpeed: '驾驶速度',
        vehicleState: '事故发生时车辆状态',
        fireFightingOrNot: '是否消防救火',
        numberOfInjured: '受伤人数',
        deathToll: '死亡人数',
        vehicleHelp: '车辆求助情况',
        vehiclePassingAccident: '车辆过往事故',
        pastAccidents: '过往事故',
        isTheWarningLampOnBeforeTheEvent: '事件发生前警告灯是否亮起',
        specificIconContent: '特定图标内容',
        didYouSmellFuelBeforeTheAccident: '事发前你闻到燃油味了吗',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident: '事发前有没有感觉到异常振动',
        abnormalSoundZone: '异响区',
        didYouHearAnyNoiseBeforeTheAccident: '事发前你听到什么噪音了吗',
        noiseDescription: '噪音描述',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: '事发前车辆起烟位置',
        otherAreas: '其他区域',
        whetherTheInsuranceCompanyHasIssuedACertificate: '保险公司是否出具了证明',
        whetherTheAuthorityIssuesTheCertificate: '权威部门是否出具证明',
        isVDSReportAvailable: '是否可以获得VDS报告',
        accidentProcess: '事发过程',
        accidentProcessPlaceholder:
            '提报人_XXXX的转述。\n' +
            '20XX年XX月XX日凌晨XX点XX分左右，当事人XXXX驾驶车牌号为XXXXXX荣威RX50 1.5/AT的车辆沿国道由南向北方向行驶（车内共一人，驾驶员一位）。当行驶至XXX省XX市XX县XX镇XX村路段处，发现左侧驾驶舱内产生白烟。',
        accessoryMaterials: '附件材料',
        bulkDownload: '批量下载',
        materialUpload: '材料上传',
        userReadmeAttachment: '用户自述附件',
        sitePhotos: '现场照片',
        fireAccidentIdentificationLetter: '火灾事故认定书',
        insuranceRecordAttachment: '保险记录附件',
        diagnosticRecords: '诊断记录',
        temperature: '温度',
        please_select_the_reporting_type: '请选择上报类型',
        fire_accident_identification_letter_required: '火灾事故认定书必选',
        please_upload_the_fire_accident_identification_letter: '请上传火灾事故认定书',
        insurance_record_attachment_required: '保险记录附件必选',
        please_upload_the_insurance_record_attachment: '请上传保险记录附件',
        please_upload_the_diagnostic_record_attachment: '请上传诊断记录附件',
        please_upload_site_photos: '请上传现场照片',
    },
    // 英
    enUS: {
        documentType: 'Document type',
        vehicleType: 'Vehicle type',
        dealerInformation: 'Dealer information',
        reportType: 'Case type',
        dealerContact: 'Dealer contact',
        contact: 'Contact #',
        customer_information: 'Customer information',
        occupation: 'Occupation',
        vehicleInformation: 'Vehicle information',
        mileage: 'Mileage (/km)',
        licensePlate: 'License plate #',
        platform: 'Platform',
        offLineDate: 'Off-line date',
        vehicleUse: 'Vehicle use',
        refited: 'Refited',
        insuranceSituation: 'Insurance situation',
        nameplateNo: 'Nameplate no',
        purchaseDate: 'Purchase date',
        accidentInformation: 'Accident information',
        timeOfAccident: 'Time of accident',
        placeOfAccident: 'Place of accident',
        roadConditions: 'Road conditions',
        pavementType: 'Pavement type',
        weather: 'Weather',
        vehicleCondition: 'Vehicle condition',
        vehicleOfTheAccident: 'Vehicle information at the time of the accident',
        vehicleCollisionPosition: 'Vehicle collision position',
        vehicleRunningStatus: 'Vehicle running status',
        ownSpeed: 'Own speed',
        vehicleSpeedOfTheOtherSide: 'Vehicle speed of the other side',
        personnelInsideTheVehicle: 'Personnel inside the vehicle',
        numberOfPeopleInTheCar: 'Number of people in the car',
        personalInjury: 'Personal injury',
        distributionOfPersonnelInTheVehicle: 'Distribution of personnel in the vehicle',
        descriptionOfPersonalInjury: 'Description of personal injury',
        airbagDeployment: 'Airbag deployment',
        safetyBeltWearing: 'Safety belt wearing',
        brakeBeforeTheAccident: 'Brake before the accident',
        turnBeforeTheIncident: 'Turn before the incident',
        whenCorrosionOccurs: 'When corrosion occurs',
        parkingTimeHours: 'Parking time (hours)',
        parkingTimeMinutes: 'Parking time (minutes)',
        drivingHours: 'Driving hours',
        drivingMinutes: 'Driving minutes',
        drivingDistance: 'Driving distance',
        drivingSpeed: 'Driving speed',
        vehicleState: 'Vehicle state',
        fireFightingOrNot: 'Fire fighting or not',
        numberOfInjured: 'Number of injured',
        deathToll: 'Death toll',
        vehicleHelp: 'Vehicle help',
        vehiclePassingAccident: 'Vehicle passing accident',
        pastAccidents: 'Past accidents',
        isTheWarningLampOnBeforeTheEvent: 'Is the warning lamp on before the event',
        specificIconContent: 'Specific icon content',
        didYouSmellFuelBeforeTheAccident: 'Did you smell fuel before the accident',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Did you feel any abnormal vibration before the accident',
        abnormalSoundZone: 'Abnormal sound zone',
        didYouHearAnyNoiseBeforeTheAccident: 'Did you hear any noise before the accident',
        noiseDescription: 'Noise description',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'The location where the vehicle started smoking before the accident occurred',
        otherAreas: 'Other areas',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Whether the insurance company has issued a certificate',
        whetherTheAuthorityIssuesTheCertificate: 'Whether the authority issues the certificate',
        isVDSReportAvailable: 'Is VDS report available',
        accidentProcess: 'Accident process',
        accidentProcessPlaceholder:
            'Reported by_ The paraphrase of XXXX.\n' +
            'At around XX a.m. on XX/XX/20XX, the party XXXX was driving a vehicle with license plate number XXXXXX Roewe RX50 1.5/AT along the national highway from south to north (with one person inside and one driver). When driving to XX Village, XX Town, XX County, XX City, XXX Province, it was found that white smoke was generated in the left cockpit.',
        accessoryMaterials: 'Attachment',
        bulkDownload: 'Bulk download',
        materialUpload: 'Material upload',
        userReadmeAttachment: 'User report attachment',
        sitePhotos: 'Photographs of the scene',
        fireAccidentIdentificationLetter: 'Fire accident confirmation',
        insuranceRecordAttachment: 'Insurance record attachment',
        diagnosticRecords: 'Diagnostic history',
        temperature: 'Temperature',
        please_select_the_reporting_type: 'Please select the reporting type',
        fire_accident_identification_letter_required:
            'Fire Accident Identification Letter Required',
        please_upload_the_fire_accident_identification_letter:
            'Please upload the fire accident identification Letter',
        insurance_record_attachment_required: 'Insurance Record Attachment Required',
        please_upload_the_insurance_record_attachment:
            'Please upload the insurance record attachment',
        please_upload_the_diagnostic_record_attachment:
            'Please upload the diagnostic record attachment',
        please_upload_site_photos: 'Please upload on-site photos',
    },
    // 德
    deDE: {
        documentType: 'Dokumenttyp',
        vehicleType: 'Fahrzeugtyp',
        dealerInformation: 'Händlerinformationen',
        reportType: 'Berichtstyp',
        dealerContact: 'Händlerkontakt',
        contact: 'Kontakt #',
        customer_information: 'Kundeninformationen',
        occupation: 'Besetzung',
        vehicleInformation: 'Fahrzeuginformationen',
        mileage: 'Laufleistung (/km)',
        licensePlate: 'Kennzeichen #',
        platform: 'Plattform',
        offLineDate: 'Off-line Datum',
        vehicleUse: 'Fahrzeugnutzung',
        refited: 'Umrüstung',
        insuranceSituation: 'Nachgefüllt',
        nameplateNo: 'Typschild Nr',
        purchaseDate: 'Kaufdatum',
        accidentInformation: 'Unfallinformationen',
        timeOfAccident: 'Zeit des Unfalls',
        placeOfAccident: 'Unfallort',
        roadConditions: 'Straßenverhältnisse',
        pavementType: 'Straßentyp',
        weather: 'Wetter',
        vehicleCondition: 'Fahrzeugzustand',
        vehicleOfTheAccident: 'Fahrzeuginformationen zum Zeitpunkt des Unfalls',
        vehicleCollisionPosition: 'Fahrzeugkollisionsposition',
        vehicleRunningStatus: 'Fahrzeugbetriebsstatus',
        ownSpeed: 'Eigene Geschwindigkeit',
        vehicleSpeedOfTheOtherSide: 'Fahrzeuggeschwindigkeit auf der anderen Seite',
        personnelInsideTheVehicle: 'Personal im Fahrzeug',
        numberOfPeopleInTheCar: 'Anzahl der Personen im Auto',
        personalInjury: 'Personenschaden',
        distributionOfPersonnelInTheVehicle: 'Verteilung des Personals im Fahrzeug',
        descriptionOfPersonalInjury: 'Beschreibung der Personenschäden',
        airbagDeployment: 'Airbag-Deployment',
        safetyBeltWearing: 'Sicherheitsgurt tragen',
        brakeBeforeTheAccident: 'Bremsen vor dem Unfall',
        turnBeforeTheIncident: 'Drehung vor dem Vorfall',
        whenCorrosionOccurs: 'Wenn Korrosion auftritt',
        parkingTimeHours: 'Parkzeit (Stunden)',
        parkingTimeMinutes: 'Parkzeit (Minuten)',
        drivingHours: 'Fahrstunden',
        drivingMinutes: 'Fahrminuten',
        drivingDistance: 'Fahrstrecke',
        drivingSpeed: 'Fahrgeschwindigkeit',
        vehicleState: 'Fahrzeugstatus',
        fireFightingOrNot: 'Feuerbekämpfung oder nicht',
        numberOfInjured: 'Anzahl der Verletzten',
        deathToll: 'Todesfälle',
        vehicleHelp: 'Fahrzeughilfe',
        vehiclePassingAccident: 'Fahrzeug überholen Unfall',
        pastAccidents: 'Vergangene Unfälle',
        isTheWarningLampOnBeforeTheEvent: 'Ist die Warnleuchte vor dem Ereignis eingeschaltet',
        specificIconContent: 'Spezifischer Symbolinhalt',
        didYouSmellFuelBeforeTheAccident: 'Hast du vor dem Unfall Benzin gerochen',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Haben Sie vor dem Unfall eine abnormale Vibration gespürt',
        abnormalSoundZone: 'Abnormale Klangzone',
        didYouHearAnyNoiseBeforeTheAccident: 'Haben Sie vor dem Unfall ein Geräusch gehört',
        noiseDescription: 'Geräuschbeschreibung',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Der Ort, an dem das Fahrzeug vor dem Unfall zu rauchen begann',
        otherAreas: 'Andere Bereiche',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Hat die Versicherungsgesellschaft eine Bescheinigung ausgestellt',
        whetherTheAuthorityIssuesTheCertificate: 'Ob die Behörde die Bescheinigung ausstellt',
        isVDSReportAvailable: 'Steht ein VDS-Bericht zur Verfügung',
        accidentProcess: 'Unfallprozess',
        accidentProcessPlaceholder:
            'Berichtet von_ Die Paraphrase von XXXX.\n' +
            'Um ca. XX Uhr auf XX/XX/20XX fuhr die Party XXXX ein Fahrzeug mit Kennzeichen XXX Roewe RX50 1.5/AT entlang der Bundesstraße von Süden nach Norden (mit einer Person im Fahrzeug und einem Fahrer). Bei der Fahrt nach XX Village, XX Town, XX County, XX City, XXX Province wurde festgestellt, dass weißer Rauch im linken Cockpit erzeugt wurde.',
        accessoryMaterials: 'Zubehörmaterialien',
        bulkDownload: 'Massendownload',
        materialUpload: 'Material-Upload',
        userReadmeAttachment: 'Benutzer-Leseanleitung Anhang',
        sitePhotos: 'Standortfotos',
        fireAccidentIdentificationLetter: 'Feuerunfall-Identifikationsbrief',
        insuranceRecordAttachment: 'Versicherungsrekord-Anhang',
        diagnosticRecords: 'Diagnostikunterlagen',
        temperature: 'Temperatur',
        please_select_the_reporting_type: 'Bitte wählen Sie die Art der Berichterstattung',
        fire_accident_identification_letter_required:
            'Kennzeichnungsschreiben für Brandunfälle erforderlich',
        please_upload_the_fire_accident_identification_letter:
            'Bitte laden Sie das Brandunfallidentifikationsformular hoch',
        insurance_record_attachment_required: 'Anhang der Versicherungsunterlagen erforderlich',
        please_upload_the_insurance_record_attachment:
            'Bitte laden Sie den Anhang der Versicherungsakte hoch',
        please_upload_the_diagnostic_record_attachment:
            'Bitte laden Sie den Anhang zur Diagnose hoch',
        please_upload_site_photos: 'Bitte laden Sie Fotos vor Ort hoch',
    },
    // 法
    frFR: {
        documentType: 'Type de document',
        vehicleType: 'Type de véhicule',
        dealerInformation: 'Informations sur le concessionnaire',
        reportType: 'Type de dossier',
        dealerContact: 'Contacts',
        contact: 'Contact #',
        customer_information: 'Informations sur le client',
        occupation: 'Occupation',
        vehicleInformation: 'Informations sur le véhicule',
        mileage: 'Kilométrage (/km)',
        licensePlate: 'Plaque d\'immatriculation',
        platform: 'Plateforme',
        offLineDate: 'Date de sortie d\'usine',
        vehicleUse: 'Utilisation du véhicule',
        refited: 'Aménagements',
        insuranceSituation: 'Etat de l\'assurance ',
        nameplateNo: 'Numéro de plaque signalétique',
        purchaseDate: 'Date d\'achat',
        accidentInformation: 'Informations sur l\'accident',
        timeOfAccident: 'Date de l\'accident',
        placeOfAccident: 'Lieu de l\'accident',
        roadConditions: 'Condition de route',
        pavementType: 'Type de chaussée',
        weather: 'Météo',
        vehicleCondition: 'Conditions du véhicule',
        vehicleOfTheAccident: 'Informations sur le véhicule au moment de l\'accident',
        vehicleCollisionPosition: 'Position du choc sur le véhicule',
        vehicleRunningStatus: 'Statut du véhicule pendant le roulage',
        ownSpeed: 'Vitesse',
        vehicleSpeedOfTheOtherSide: 'Vitesse de l\'autre véhicule',
        personnelInsideTheVehicle: 'Emplacement des personne dans le véhicule',
        numberOfPeopleInTheCar: 'Nombre de personnes dans le véhicule',
        personalInjury: 'Nombre de personnes blessées',
        distributionOfPersonnelInTheVehicle: 'Répartition du personnel dans le véhicule',
        descriptionOfPersonalInjury: 'Description de la blessure personnelle',
        airbagDeployment: 'Déploiement des airbags ',
        safetyBeltWearing: 'Port des ceintures de sécurité',
        brakeBeforeTheAccident: 'Freinage avant l\'accident',
        turnBeforeTheIncident: 'Virage avant l\'accident',
        whenCorrosionOccurs: 'Moment d\'apparition de la corrosion',
        parkingTimeHours: 'Temps de stationnement (heures)',
        parkingTimeMinutes: 'Temps de stationnement (minutes)',
        drivingHours: 'Heures de conduite',
        drivingMinutes: 'Minutes de conduite',
        drivingDistance: 'Distance de conduite',
        drivingSpeed: 'Vitesse de conduite',
        vehicleState: 'Etat du véhicule',
        fireFightingOrNot: 'lutte contre l\'incendie ou non ?',
        numberOfInjured: 'Nombre de blessés',
        deathToll: 'Nombre de décès',
        vehicleHelp: 'Service d\'urgence',
        vehiclePassingAccident: 'Accident avec un véhicule de passage',
        pastAccidents: 'Accidents passés',
        isTheWarningLampOnBeforeTheEvent: 'Voyant allumé avant l\'accident',
        specificIconContent: 'Contenu spécifique de l\'icône',
        didYouSmellFuelBeforeTheAccident:
            'Avez-vous senti une odeur de carburant avant l\'accident ?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Avez-vous senti des vibrations avant l\'accident ?',
        abnormalSoundZone: 'Zone de bruit anormal',
        didYouHearAnyNoiseBeforeTheAccident: 'Avez-vous entendu un bruit avant l\'accident ?',
        noiseDescription: 'Description du bruit',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Une zone fumait avant l\'accident ?',
        otherAreas: 'Autres zones',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Certificat d\'assurance conforme',
        whetherTheAuthorityIssuesTheCertificate: 'Carte grise conforme',
        isVDSReportAvailable: 'Un rapport VDS est possible',
        accidentProcess: 'Etat du processus d\'accident',
        accidentProcessPlaceholder:
            'Déclarant Paraphrase de XXXX.\n' +
            '20XX le xx xx xx, vers 20hxx, la partie XXXX conduisait un véhicule immatriculé XXXXXX ronway rx50 1.5 / at sur la route nationale en direction du Sud et du Nord (une personne à l\'intérieur du véhicule, un conducteur). Lorsque vous conduisez jusqu\'à la Section du village XX, Canton XX, comté XX, municipalité XX, Province XXX, de la fumée blanche a été trouvée dans le cockpit gauche.',
        accessoryMaterials: 'Pièces-jointes',
        bulkDownload: 'Téléchargement en vrac',
        materialUpload: 'Téléchargement de matériel',
        userReadmeAttachment: 'Constat de l\'accident',
        sitePhotos: 'Photos',
        fireAccidentIdentificationLetter: 'Confirmation de l\'incendie',
        insuranceRecordAttachment: 'Pièces-jointes de l\'assurance',
        diagnosticRecords: 'Historique de d\'atelier',
        temperature: 'Température',
        please_select_the_reporting_type: 'Veuillez sélectionner le type d\'escalade',
        fire_accident_identification_letter_required:
            'Certificat d\'accident d\'incendie obligatoire',
        please_upload_the_fire_accident_identification_letter:
            'Veuillez télécharger une déclaration d\'accident d\'incendie',
        insurance_record_attachment_required: 'Pièce jointe au dossier d\'assurance obligatoire',
        please_upload_the_insurance_record_attachment:
            'Veuillez télécharger une pièce jointe au dossier d\'assurance',
        please_upload_the_diagnostic_record_attachment:
            'Veuillez télécharger une pièce jointe au dossier de diagnostic',
        please_upload_site_photos: 'Veuillez télécharger une photo du site',
    },
    // 意大利
    itIT: {
        documentType: 'Tipo di documento',
        vehicleType: 'Tipo di veicolo',
        dealerInformation: 'Informazioni sul concessionario',
        reportType: 'Tipo di rapporto',
        dealerContact: 'Contatto del concessionario',
        contact: 'Contatto telefonico',
        customer_information: 'Informazioni sul cliente',
        occupation: 'Occupazione',
        vehicleInformation: 'Informazioni sul veicolo',
        mileage: 'Chilometraggio/km',
        licensePlate: 'Targa',
        platform: 'Piattaforma del modello',
        offLineDate: 'Data di uscita di produzione',
        vehicleUse: 'Utilizzo del veicolo',
        refited: 'Modifiche eseguite',
        insuranceSituation: 'Situazione assicurativa',
        nameplateNo: 'Numero di targa',
        purchaseDate: 'Data di acquisto',
        accidentInformation: 'Informazioni sull\'incidente',
        timeOfAccident: 'Orario in cui si è verificato l\'incidente',
        placeOfAccident: 'Luogo dell\'incidente',
        roadConditions: 'Condizioni della strada',
        pavementType: 'Tipo di pavimentazione',
        weather: 'Condizioni meteorologiche',
        vehicleCondition: 'Condizioni del veicolo',
        vehicleOfTheAccident: 'Informazioni sul veicolo coinvolto nell\'incidente',
        vehicleCollisionPosition: 'Posizione di impatto del veicolo',
        vehicleRunningStatus: 'Stato di marcia del veicolo',
        ownSpeed: 'Velocità del proprio veicolo',
        vehicleSpeedOfTheOtherSide: 'Velocità del veicolo dell\'altro conducente',
        personnelInsideTheVehicle:
            'Situazione delle persone all\'interno del veicolo coinvolto nell\'incidente',
        numberOfPeopleInTheCar: 'Numero di persone a bordo del veicolo',
        personalInjury: 'Condizioni delle persone ferite',
        distributionOfPersonnelInTheVehicle:
            'Posizione delle persone ferite all\'interno del veicolo',
        descriptionOfPersonalInjury: 'Descrizione delle condizioni delle persone ferite',
        airbagDeployment: 'Attivazione dell\'airbag',
        safetyBeltWearing: 'Utilizzo delle cinture di sicurezza',
        brakeBeforeTheAccident: 'Utilizzo dei freni prima dell\'incidente',
        turnBeforeTheIncident: 'Svolta prima dell\'incidente',
        whenCorrosionOccurs: 'Quando si è verificata la corrosione',
        parkingTimeHours: 'Tempo di parcheggio (ore)',
        parkingTimeMinutes: 'Tempo di parcheggio (minuti)',
        drivingHours: 'Ore di guida',
        drivingMinutes: 'Minuti di guida',
        drivingDistance: 'Distanza percorsa',
        drivingSpeed: 'Velocità di guida',
        vehicleState: 'Condizioni del veicolo al momento dell\'incidente',
        fireFightingOrNot: 'Intervento antincendio',
        numberOfInjured: 'Numero di feriti',
        deathToll: 'Numero di morti',
        vehicleHelp: 'Richiesta di aiuto per il veicolo',
        vehiclePassingAccident: 'Veicolo coinvolto in incidenti precedenti',
        pastAccidents: 'Incidenti precedenti',
        isTheWarningLampOnBeforeTheEvent: 'Spia di avvertimento accesa prima dell\'incidente',
        specificIconContent: 'Contenuto degli icone specifici',
        didYouSmellFuelBeforeTheAccident: 'Hai percepito odore di carburante prima dell\'incidente',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Hai percepito vibrazioni anomale prima dell\'incidente',
        abnormalSoundZone: 'Zona di rumore anomalo',
        didYouHearAnyNoiseBeforeTheAccident: 'Hai sentito rumori prima dell\'incidente',
        noiseDescription: 'Descrizione del rumore',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Il luogo in cui il veicolo ha iniziato a fumare prima dell\'incidente',
        otherAreas: 'Altre zone',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'L\'azienda di assicurazione ha emesso il certificato\'',
        whetherTheAuthorityIssuesTheCertificate: 'L\'autorità ha emesso il certificato',
        isVDSReportAvailable: 'Disponibilità del rapporto VDS',
        accidentProcess: 'Processo dell\'incidente',
        accidentProcessPlaceholder:
            'Segnalato da_ La parafrasi di XXXX.\n' +
            'Verso le ore 20.00 del XX/XX/20XX, la festa XXXX guidava un veicolo con targa XXX Roewe RX50 1.5/AT lungo l\'autostrada nazionale da sud a nord (con una persona nel veicolo e un autista). Durante la guida verso XX Village, XX Town, XX County, XX City, XXX Province, è stato scoperto che il fumo bianco era generato nella cabina di pilotaggio sinistra.',
        accessoryMaterials: 'Materiale accessorio',
        bulkDownload: 'Download in blocco',
        materialUpload: 'Caricamento materiale',
        userReadmeAttachment: 'Allegato di presentazione dell\'utente',
        sitePhotos: 'Foto del sito',
        fireAccidentIdentificationLetter: 'Lettera di identificazione dell\'incidente di incendio',
        insuranceRecordAttachment: 'Allegato record assicurativo',
        diagnosticRecords: 'Registri diagnostici',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Seleziona il tipo di segnalazione',
        fire_accident_identification_letter_required:
            'Lettera di identificazione degli incidenti antincendio richiesta',
        please_upload_the_fire_accident_identification_letter:
            'Si prega di caricare il modulo di identificazione degli incidenti antincendio',
        insurance_record_attachment_required: 'Obbligo di allegare il registro assicurativo',
        please_upload_the_insurance_record_attachment:
            'Si prega di caricare l\'allegato della scheda assicurativa',
        please_upload_the_diagnostic_record_attachment:
            'Carica l\'allegato della scheda diagnostica',
        please_upload_site_photos: 'Si prega di caricare foto in loco',
    },
    // 荷兰
    nlNL: {
        documentType: 'Document type',
        vehicleType: 'Vehicle type',
        dealerInformation: 'Dealer informatie',
        reportType: 'Rapporttype',
        dealerContact: 'Dealer contact',
        contact: 'Contact #',
        customer_information: 'Klantgegevens',
        occupation: 'Beroep',
        vehicleInformation: 'Voertuiginformatie',
        mileage: 'Kilometerstand (/km)',
        licensePlate: 'Kenteken #',
        platform: 'Platform',
        offLineDate: 'Offline datum',
        vehicleUse: 'Voertuiggebruik',
        refited: 'Gerenoveerd',
        insuranceSituation: 'Nachgefüllt',
        nameplateNo: 'Typegoedkeuringnummer',
        purchaseDate: 'Aankoopdatum',
        accidentInformation: 'Ongevalsinformatie',
        timeOfAccident: 'Tijdstip van ongeval',
        placeOfAccident: 'Plaats van ongeval',
        roadConditions: 'Wegomstandigheden',
        pavementType: 'Wegdektype',
        weather: 'Weer',
        vehicleCondition: 'Voertuigconditie',
        vehicleOfTheAccident: 'Voertuiginformatie op het moment van het ongeval',
        vehicleCollisionPosition: 'Positie van de voertuigbotsing',
        vehicleRunningStatus: 'Voertuigrijstatus',
        ownSpeed: 'Eigen snelheid',
        vehicleSpeedOfTheOtherSide: 'Voertuigsnelheid van de andere kant',
        personnelInsideTheVehicle: 'Personeel in het voertuig',
        numberOfPeopleInTheCar: 'Aantal personen in de auto',
        personalInjury: 'Persoonlijk letsel',
        distributionOfPersonnelInTheVehicle: 'Verdeling van personeel in het voertuig',
        descriptionOfPersonalInjury: 'Beschrijving van persoonlijk letsel',
        airbagDeployment: 'Airbag-ontplooiing',
        safetyBeltWearing: 'Veiligheidsgordel dragen',
        brakeBeforeTheAccident: 'Remmen voor het ongeval',
        turnBeforeTheIncident: 'Bocht voor het incident',
        whenCorrosionOccurs: 'Wanneer corrosie optreedt',
        parkingTimeHours: 'Parkeertijd (uren)',
        parkingTimeMinutes: 'Parkeertijd (minuten)',
        drivingHours: 'Rijuren',
        drivingMinutes: 'Rijminuten',
        drivingDistance: 'Rijafstand',
        drivingSpeed: 'Rijsnelheid',
        vehicleState: 'Voertuigstatus',
        fireFightingOrNot: 'Brandbestrijding of niet',
        numberOfInjured: 'Aantal gewonden',
        deathToll: 'Doodstol',
        vehicleHelp: 'Voertuighulp',
        vehiclePassingAccident: 'Voertuig dat het ongeval passeert',
        pastAccidents: 'Eerdere ongevallen',
        isTheWarningLampOnBeforeTheEvent: 'Is het waarschuwingslampje aan voor het evenement',
        specificIconContent: 'Specifieke pictograminhoud',
        didYouSmellFuelBeforeTheAccident: 'Heb je brandstof geroken voor het ongeval',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Voelde u een abnormale trilling voor het ongeval',
        abnormalSoundZone: 'Zone met abnormaal geluid',
        didYouHearAnyNoiseBeforeTheAccident: 'Heeft u geluid gehoord voor het ongeval',
        noiseDescription: 'Beschrijving van het geluid',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Locatie van de rook van het voertuig vóór het incident',
        otherAreas: 'Andere gebieden',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Heeft de verzekeringsmaatschappij een certificaat afgegeven',
        whetherTheAuthorityIssuesTheCertificate: 'Of de autoriteit het certificaat afgeeft',
        isVDSReportAvailable: 'Is er een VDS-rapport beschikbaar',
        accidentProcess: 'Ongeval proces',
        accidentProcessPlaceholder:
            'Geregistreerd door_ De parafrase van XXXX.\n' +
            'Rond XX a.m. op XX/XX/20XX reed de partij XXXX met een voertuig met kentekennummer XXX Roewe RX50 1.5/AT over de nationale snelweg van zuid naar noord (met één persoon in het voertuig en één bestuurder). Bij het rijden naar XX Village, XX Town, XX County, XX City, XXX Province, bleek dat witte rook werd gegenereerd in de linkercockpit.',
        accessoryMaterials: 'Accessoire materialen',
        bulkDownload: 'Bulk download',
        materialUpload: 'Materiaal uploaden',
        userReadmeAttachment: 'Gebruikershandleiding bijlage',
        sitePhotos: 'Site foto\'s',
        fireAccidentIdentificationLetter: 'Identificatiebrief van brandongevallen',
        insuranceRecordAttachment: 'Verzekeringsregistratie bijlage',
        diagnosticRecords: 'Diagnostische gegevens',
        temperature: 'Temperatuur',
        please_select_the_reporting_type: 'Selecteer het type rapportage',
        fire_accident_identification_letter_required:
            'Noodzakelijke identificatiebrief voor brandongevallen',
        please_upload_the_fire_accident_identification_letter:
            'Upload het identificatieformulier voor brandongevallen',
        insurance_record_attachment_required: 'Vereist beslag op verzekeringsdocumenten',
        please_upload_the_insurance_record_attachment:
            'Upload de bijlage van het verzekeringsdossier',
        please_upload_the_diagnostic_record_attachment:
            'Upload de bijlage van de diagnostische record',
        please_upload_site_photos: 'Upload foto\'s ter plaatse',
    },
    // 越南
    viVN: {
        documentType: 'Loại tài liệu',
        vehicleType: 'Loại xe',
        dealerInformation: 'Thông tin nhà phân phối',
        reportType: 'Loại trường hợp',
        dealerContact: 'Người liên hệ nhà phân phối',
        contact: 'Số liên hệ',
        customer_information: 'Thông tin khách hàng',
        occupation: 'Nghề nghiệp',
        vehicleInformation: 'Thông tin xe',
        mileage: 'Số km đã đi (/km)',
        licensePlate: 'Biển số xe',
        platform: 'Nền tảng',
        offLineDate: 'Ngày off-line',
        vehicleUse: 'Sử dụng xe',
        refited: 'Được trang bị lại',
        insuranceSituation: 'Tình trạng bảo hiểm',
        nameplateNo: 'Số tem đóng lên xe',
        purchaseDate: 'Ngày mua',
        accidentInformation: 'Thông tin về tai nạn',
        timeOfAccident: 'Thời gian tai nạn',
        placeOfAccident: 'Điạ điểm xẩy ra tai nạn',
        roadConditions: 'Tình trạng đường',
        pavementType: 'Loại mặt đường',
        weather: 'Thời tiết',
        vehicleCondition: 'Tình trạng xe',
        vehicleOfTheAccident: 'Thông tin xe trong lúc xảy ra tai nạn',
        vehicleCollisionPosition: 'Vị trí va chạm trên xe',
        vehicleRunningStatus: 'Tình trạng hoạt động của xe',
        ownSpeed: 'Tốc độ',
        vehicleSpeedOfTheOtherSide: 'Tốc độ của phía bên kia',
        personnelInsideTheVehicle: 'Tình hình nhân viên trong xe xảy ra tai nạn',
        numberOfPeopleInTheCar: 'Số người trong xe',
        personalInjury: 'Chấn thương về người',
        distributionOfPersonnelInTheVehicle: 'Phân bổ người ngồi trong xe',
        descriptionOfPersonalInjury: 'Miêu tả tình trạng thương tật của người',
        airbagDeployment: 'Túi khí hoạt động',
        safetyBeltWearing: 'Thắt đai an toàn',
        brakeBeforeTheAccident: 'Thắng trước khi tai nạn',
        turnBeforeTheIncident: 'Rẻ trước khi tai nạn',
        whenCorrosionOccurs: 'Xẩy ra va chạm khi nào',
        parkingTimeHours: 'Thời gian đỗ xe (giờ)',
        parkingTimeMinutes: 'Thời gian đỗ xe (phút)',
        drivingHours: 'Thời gian lái xe (giờ)',
        drivingMinutes: 'Thời gian lái xe (phút)',
        drivingDistance: 'Khoảng cách đã lái xe',
        drivingSpeed: 'Tốc độ lái xe',
        vehicleState: 'Trạng thái xe',
        fireFightingOrNot: 'Chữa cháy hoặc không',
        numberOfInjured: 'Số người bị thương',
        deathToll: 'Số người tử vong',
        vehicleHelp: 'Xe hỗ trợ',
        vehiclePassingAccident: 'Xe đi qua vụ tai nạn',
        pastAccidents: 'Tai nạn trong quá khứ',
        isTheWarningLampOnBeforeTheEvent: 'Đèn cảnh báo có sáng trước khi xẩy ra',
        specificIconContent: 'Nội dung biểu tượng cụ thể',
        didYouSmellFuelBeforeTheAccident: 'Bạn có ngửi thấy mùi nhiên liệu trước khi tai nạn',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Bạn có cảm nhận bất kỳ rung động bất thường nào trước khi xẩy ra tai nạn',
        abnormalSoundZone: 'Khu vực tiếng ồn không bình thường',
        didYouHearAnyNoiseBeforeTheAccident: 'Bạn có nghe bất kỳ âm thanh gì trước khi tai nạn',
        noiseDescription: 'Miêu tả âm thanh',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Vị trí trên xe bốc khói trước khi tai nạn',
        otherAreas: 'Các khu vực khác',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Công ty bảo hiểm có cấp giấy chứng nhận',
        whetherTheAuthorityIssuesTheCertificate: 'Cơ quan nhà nước có cấp giấy chứng nhận',
        isVDSReportAvailable: 'Có báo cáo VDS không',
        accidentProcess: 'Diễn biến tai nạn',
        accidentProcessPlaceholder:
            'Báo cáo của người gửi_XXXX.\n' +
            'Vào khoảng XX giờ XX phút sáng ngày XX tháng XX năm 20XX, tại đoạn đường thuộc xã XX, huyện XX, tỉnh XXX, khi đang lái xe ô tô biển số XXXXXX dòng RX50 1.5/AT của hãng Roewe theo hướng từ phía Nam đi Bắc (trong xe có một người, là tài xế). Khi đi đến đoạn đường thuộc xã XX, huyện XX, tỉnh XXX, thì phát hiện có khói trắng bốc lên từ trong khoang lái.',
        accessoryMaterials: 'Tệp đính kèm',
        bulkDownload: 'Tải xuống tập tin hàng loạt',
        materialUpload: 'Tải lên tài liệu',
        userReadmeAttachment: 'Đính kèm tệp báo cáo của người sử dụng',
        sitePhotos: 'Ảnh hiện trường',
        fireAccidentIdentificationLetter: 'Xác nhận tai nạn cháy nổ',
        insuranceRecordAttachment: 'Báo cáo hồ sơ bảo hiểm',
        diagnosticRecords: 'Lịch sử đọc lỗi',
        temperature: 'Nhiệt độ',
        please_select_the_reporting_type: 'Vui lòng chọn loại báo cáo',
        fire_accident_identification_letter_required: 'Yêu cầu có thư xác định tai nạn cháy',
        please_upload_the_fire_accident_identification_letter:
            'Vui lòng tải lên thư xác định tai nạn cháy',
        insurance_record_attachment_required: 'Yêu cầu tệp ghi nhận bảo hiểm',
        please_upload_the_insurance_record_attachment: 'Vui lòng tải lên tệp ghi nhận bảo hiểm',
        please_upload_the_diagnostic_record_attachment: 'Vui lòng tải lên tệp ghi nhận chẩn đoán',
        please_upload_site_photos: 'Vui lòng tải lên ảnh hiện trường',
    },
    // 西班牙
    esES: {
        documentType: 'Tipo de documento',
        vehicleType: 'Tipo de vehículo',
        dealerInformation: 'Información del distribuidor',
        reportType: 'Tipo de informe',
        dealerContact: 'Persona de contacto del distribuidor',
        contact: 'Teléfono de contacto',
        customer_information: 'Información del cliente',
        occupation: 'Profesión',
        vehicleInformation: 'Información del vehículo',
        mileage: 'Kilometraje recorrido/km',
        licensePlate: 'Número de matrícula',
        platform: 'Plataforma del modelo del vehículo',
        offLineDate: 'Fecha de producción',
        vehicleUse: 'Uso del vehículo',
        refited: '¿Ha sido modificado o agregado algo?',
        insuranceSituation: 'Estado del seguro',
        nameplateNo: 'Número de placa',
        purchaseDate: 'Fecha de compra',
        accidentInformation: 'Información sobre el accidente',
        timeOfAccident: 'Fecha del accidente',
        placeOfAccident: 'Lugar del accidente',
        roadConditions: 'Estado de la carretera',
        pavementType: 'Tipo de pavimento',
        weather: 'Clima',
        vehicleCondition: 'Estado del vehículo',
        vehicleOfTheAccident: 'Información del vehículo en el momento del accidente',
        vehicleCollisionPosition: 'Ubicación del impacto en el vehículo',
        vehicleRunningStatus: 'Estado de conducción del vehículo',
        ownSpeed: 'Velocidad del vehículo propio',
        vehicleSpeedOfTheOtherSide: 'Velocidad del vehículo contrario',
        personnelInsideTheVehicle:
            'Información de los ocupantes del vehículo en el momento del accidente',
        numberOfPeopleInTheCar: 'Número de ocupantes',
        personalInjury: 'Lesiones de los ocupantes',
        distributionOfPersonnelInTheVehicle: 'Posición de los ocupantes lesionados',
        descriptionOfPersonalInjury: 'Descripción de las lesiones de los ocupantes',
        airbagDeployment: 'Activación de los airbags',
        safetyBeltWearing: 'Uso del cinturón de seguridad',
        brakeBeforeTheAccident: 'Frenado antes del accidente',
        turnBeforeTheIncident: 'Giro antes del accidente',
        whenCorrosionOccurs: 'Cuándo ocurrió la corrosión',
        parkingTimeHours: 'Tiempo de estacionamiento (horas)',
        parkingTimeMinutes: 'Tiempo de estacionamiento (minutos)',
        drivingHours: 'Horas de conducción',
        drivingMinutes: 'Minutos de conducción',
        drivingDistance: 'Distancia de conducción',
        drivingSpeed: 'Velocidad de conducción',
        vehicleState: 'Estado del vehículo en el momento del accidente',
        fireFightingOrNot: '¿Se utilizó equipo de extinción de incendios?',
        numberOfInjured: 'Número de personas lesionadas',
        deathToll: 'Número de personas fallecidas',
        vehicleHelp: 'Situación de ayuda del vehículo',
        vehiclePassingAccident: 'Historial de accidentes anteriores del vehículo',
        pastAccidents: 'Accidentes anteriores',
        isTheWarningLampOnBeforeTheEvent:
            '¿Se encendió alguna luz de advertencia antes del incidente?',
        specificIconContent: 'Contenido del icono específico',
        didYouSmellFuelBeforeTheAccident: '¿Olió a combustible antes del incidente?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            '¿Sintió alguna vibración anormal antes del incidente?',
        abnormalSoundZone: 'Zona de ruidos extraños',
        didYouHearAnyNoiseBeforeTheAccident: '¿Escuchó algún ruido antes del incidente?',
        noiseDescription: 'Descripción del ruido',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Ubicación del humo en el vehículo antes del incidente',
        otherAreas: 'Otra área',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            '¿La compañía de seguros emitió una certificación?',
        whetherTheAuthorityIssuesTheCertificate:
            '¿Se emitió un informe por parte de una autoridad competente?',
        isVDSReportAvailable: '¿Es posible obtener un informe VDS?',
        accidentProcess: 'Proceso del incidente',
        accidentProcessPlaceholder:
            '"Declaración del usuario_XXXX.\n' +
            'El XX de XX de 20XX, aproximadamente a las XX:XX am, el usuario XXXX conducía el vehículo con matrícula XXXXXX, modelo Roewe RX50 1.5/AT, viajando de sur a norte por la carretera nacional (el conductor era el único ocupante). Cuando se encontraba en la localidad de XX, en el municipio de XX, provincia de XXXX, se observó humo blanco en la cabina del lado izquierdo.","',
        accessoryMaterials: 'Documentos adjuntos',
        bulkDownload: 'Descargar varios',
        materialUpload: 'Cargar documentos',
        userReadmeAttachment: 'Adjunto de declaración del usuario',
        sitePhotos: 'Fotografías del lugar del incidente',
        fireAccidentIdentificationLetter: 'Informe de determinación del incendio',
        insuranceRecordAttachment: 'Archivo de registro de seguro',
        diagnosticRecords: 'Registro de diagnóstico',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Seleccione el tipo de informe',
        fire_accident_identification_letter_required:
            'Se requiere el informe de determinación del incendio',
        please_upload_the_fire_accident_identification_letter:
            'Cargue el informe de determinación del incendio',
        insurance_record_attachment_required: 'Se requiere el archivo de registro de seguro',
        please_upload_the_insurance_record_attachment: 'Cargue el archivo de registro de seguro',
        please_upload_the_diagnostic_record_attachment:
            'Cargue el archivo de registro de diagnóstico',
        please_upload_site_photos: 'Cargue las fotografías del lugar del incidente',
    },
    // 葡萄牙
    ptBR: {
        documentType: 'Tipo de documento',
        vehicleType: 'Tipo de veículo',
        dealerInformation: 'Informações do revendedor',
        reportType: 'Tipo de relatório',
        dealerContact: 'Contato do revendedor',
        contact: 'Telefone de contato',
        customer_information: 'Informações do cliente',
        occupation: 'Profissão',
        vehicleInformation: 'Informações do veículo',
        mileage: 'Quilometragem percorrida/km',
        licensePlate: 'Placa do veículo',
        platform: 'Plataforma do modelo',
        offLineDate: 'Data de desativação',
        vehicleUse: 'Uso do veículo',
        refited: 'Possui modificações',
        insuranceSituation: 'Situação do seguro',
        nameplateNo: 'Número da placa',
        purchaseDate: 'Data de compra',
        accidentInformation: 'Informações do acidente',
        timeOfAccident: 'Horário do acidente',
        placeOfAccident: 'Local do acidente',
        roadConditions: 'Condições da estrada',
        pavementType: 'Tipo de pavimento',
        weather: 'Clima',
        vehicleCondition: 'Condição do veículo',
        vehicleOfTheAccident: 'Informações do veículo no momento do acidente',
        vehicleCollisionPosition: 'Posição de colisão do veículo',
        vehicleRunningStatus: 'Estado de movimento do veículo',
        ownSpeed: 'Velocidade própria',
        vehicleSpeedOfTheOtherSide: 'Velocidade do outro veículo',
        personnelInsideTheVehicle: 'Situação dos ocupantes do veículo',
        numberOfPeopleInTheCar: 'Número de pessoas no veículo',
        personalInjury: 'Lesões pessoais',
        distributionOfPersonnelInTheVehicle: 'Distribuição dos ocupantes do veículo',
        descriptionOfPersonalInjury: 'Descrição das lesões pessoais',
        airbagDeployment: 'Ativação da bolsa de ar',
        safetyBeltWearing: 'Uso do cinto de segurança',
        brakeBeforeTheAccident: 'Freio antes do acidente',
        turnBeforeTheIncident: 'Manobra antes do acidente',
        whenCorrosionOccurs: 'Momento em que ocorreu a corrosão',
        parkingTimeHours: 'Tempo de estacionamento (horas)',
        parkingTimeMinutes: 'Tempo de estacionamento (minutos)',
        drivingHours: 'Tempo de condução (horas)',
        drivingMinutes: 'Tempo de condução (minutos)',
        drivingDistance: 'Distância percorrida',
        drivingSpeed: 'Velocidade de condução',
        vehicleState: 'Estado do veículo no momento do acidente',
        fireFightingOrNot: 'Presença de combate a incêndio',
        numberOfInjured: 'Número de feridos',
        deathToll: 'Número de mortos',
        vehicleHelp: 'Situação do veículo que solicitou ajuda',
        vehiclePassingAccident: 'Acidentes anteriores envolvendo o veículo',
        pastAccidents: 'Acidentes anteriores',
        isTheWarningLampOnBeforeTheEvent: 'A luz de advertência estava acesa antes do evento',
        specificIconContent: 'Conteúdo do ícone específico',
        didYouSmellFuelBeforeTheAccident: 'Você sentiu cheiro de combustível antes do acidente',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Você sentiu alguma vibração anormal antes do acidente',
        abnormalSoundZone: 'Zona de ruído anormal',
        didYouHearAnyNoiseBeforeTheAccident: 'Você ouviu algum barulho antes do acidente',
        noiseDescription: 'Descrição do ruído',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Área onde o veículo emitia fumaça antes do acidente',
        otherAreas: 'Outras áreas',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'A seguradora emitiu um certificado',
        whetherTheAuthorityIssuesTheCertificate: 'A autoridade emitiu um certificado',
        isVDSReportAvailable: 'É possível obter o relatório VDS',
        accidentProcess: 'Processo do acidente',
        accidentProcessPlaceholder:
            'Relato de XXXX Transmitido por XXXX.\n' +
            'Por volta das XXhXXmin da madrugada de XX de XXXX de 20XX, a pessoa envolvida XXXX dirigia o veículo XXXXXX, modelo do carro XXXXXXXXXX RX50 1.5/AT, ao longo da rodovia no sentido sul-norte (apenas o motorista estava no veículo). Ao passar pela localidade de XX, cidade de XX, condado de XX, vila de XX, ocorreu a emissão de fumaça branca dentro da cabine do lado esquerdo.',
        accessoryMaterials: 'Materiais complementares',
        bulkDownload: 'Download em massa',
        materialUpload: 'Upload de materiais',
        userReadmeAttachment: 'Anexo de descrição do usuário',
        sitePhotos: 'Fotos do local',
        fireAccidentIdentificationLetter: 'Carta de Identificação do Acidente de Incêndio',
        insuranceRecordAttachment: 'Anexo de registro de seguro',
        diagnosticRecords: 'Registros de diagnóstico',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Por favor, selecione o tipo de relatório',
        fire_accident_identification_letter_required:
            'A carta de identificação do acidente de incêndio é obrigatória',
        please_upload_the_fire_accident_identification_letter:
            'Por favor, faça o upload da carta de identificação do acidente de incêndio',
        insurance_record_attachment_required: 'O anexo de registro de seguro é obrigatório',
        please_upload_the_insurance_record_attachment:
            'Por favor, faça o upload do anexo de registro de seguro',
        please_upload_the_diagnostic_record_attachment:
            'Por favor, faça o upload do anexo de registro de diagnóstico',
        please_upload_site_photos: 'Por favor, faça o upload das fotos do local',
    },
    // 波兰
    plPL: {
        documentType: 'Typ dokumentu',
        vehicleType: 'Typ pojazdu',
        dealerInformation: 'Informacje o dealerze',
        reportType: 'Typ sprawy',
        dealerContact: 'Kontakt  do dealera',
        contact: 'Kontakt',
        customer_information: 'Informacje o kliencie',
        occupation: 'wykonywany zawód',
        vehicleInformation: 'Informacje o pojeździe',
        mileage: 'Przebieg/km',
        licensePlate: 'Numer rejestracyjny',
        platform: 'Platforma',
        offLineDate: 'Data zejścia z linii',
        vehicleUse: 'Użytkowanie pojazdu',
        refited: 'Zmiana wyposażenia',
        insuranceSituation: 'Sytuacja ubezpieczenia',
        nameplateNo: 'Numer plakietki znamionowej',
        purchaseDate: 'Data zakupu',
        accidentInformation: 'Informacje o wypadkach',
        timeOfAccident: 'Data wypadku',
        placeOfAccident: 'Miejsce wypadku',
        roadConditions: 'Warunki drogowe',
        pavementType: 'Rodzaj nawierzchni',
        weather: 'Pogoda',
        vehicleCondition: 'Stan pojadu',
        vehicleOfTheAccident: 'Informacje o pojeździe w chwili wypadku',
        vehicleCollisionPosition: 'Miejsce kolizji pojazdu',
        vehicleRunningStatus: 'Stan jazdy',
        ownSpeed: 'Prędkość własna',
        vehicleSpeedOfTheOtherSide: 'Prędkość drugiego pojazdu',
        personnelInsideTheVehicle: 'Załoga pojazdu',
        numberOfPeopleInTheCar: 'Ilość osób w pojeździe',
        personalInjury: 'Obrażenia',
        distributionOfPersonnelInTheVehicle: 'Miejsce poszkodowanych',
        descriptionOfPersonalInjury: 'Opis obrażeń',
        airbagDeployment: 'Wyzwolenie poduszki powietrznej',
        safetyBeltWearing: 'Stan zapięcia pasów bezpieczeństwa',
        brakeBeforeTheAccident: 'Hamowanie przed kolizją',
        turnBeforeTheIncident: 'Skręcanie przed kolizją',
        whenCorrosionOccurs: 'Kiedy występuje korozja',
        parkingTimeHours: 'Czas parkowania (w godzinach)',
        parkingTimeMinutes: 'Czas parkowania (w minutach)',
        drivingHours: 'Godziny jazdy',
        drivingMinutes: 'Minuty jazdy',
        drivingDistance: 'Dystans',
        drivingSpeed: 'Prędkość jazdy',
        vehicleState: 'Stan pojazdu podczas kolizji',
        fireFightingOrNot: 'Czy straż pożarna gasiła ogień',
        numberOfInjured: 'Ilość osób poszkodowanych',
        deathToll: 'Liczba ofiar śmiertelnych',
        vehicleHelp: 'Pomoc pojazdu',
        vehiclePassingAccident: 'Wypadek przejeżdżającego pojazdu',
        pastAccidents: 'Wcześcniejsze kolizje',
        isTheWarningLampOnBeforeTheEvent: 'Czy światła awaryjne paliły się przed zdarzeniem',
        specificIconContent: 'Określona zawartość ikony',
        didYouSmellFuelBeforeTheAccident: 'Czy przed kolizją wyczuwalny był zapach paliwa',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Czy przed kolizją wyczuwalne były nietypowe wibracje',
        abnormalSoundZone: 'Strefa nietypowych dźwięków',
        didYouHearAnyNoiseBeforeTheAccident: 'Czy s luchać było jakieś dźwięki przed wypadkiem',
        noiseDescription: 'Opis dźwięków',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Miejsce, w krórym pojawił się ogień przed wypadkiem',
        otherAreas: 'Inne obszary',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Czy ubezpieczyciel wydał certyfikat',
        whetherTheAuthorityIssuesTheCertificate: 'Czy ubezpieczyciel wydał certyfikat',
        isVDSReportAvailable: 'Czy dostępny jest raport VDS',
        accidentProcess: 'Przebieg wypadku',
        accidentProcessPlaceholder:
            'Opis przekazany przez XXXX.\\n + \'Około godziny XX przed południem, dnia XX/XX/20XX, uczestnik XXXX prowadził pojazd Roewe RX50 1.5T/AT o numerze rejestracyjnym XXXXXX po drodze krajowej jadąc z południa na północ (z jednym pasażerem i jeden kierowca). Podczas jazdy do miejscowości XX, miasta CC, województwa XX stwierdzono, że po lewej stronie kokpitu wydobywał się biały dym.',
        accessoryMaterials: 'Załącznik',
        bulkDownload: 'Pobieranie zbiorcze',
        materialUpload: 'Przesyłanie materiałów',
        userReadmeAttachment: 'Załącznik raportu użytkownika',
        sitePhotos: 'Zdjęcia miejsca kolizji',
        fireAccidentIdentificationLetter: 'Potwierdzenie wystąpienia pożaru podczas kolizji',
        insuranceRecordAttachment: 'Załącznik protokołu ubezpieczenia',
        diagnosticRecords: 'Historia diagnostyczna',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Proszę wybrać typ raportu',
        fire_accident_identification_letter_required:
            'Wymagane pismo identyfikacji wypadku pożarowego',
        please_upload_the_fire_accident_identification_letter:
            'Prześlij pismo identyfikacji wypadku pożarowego',
        insurance_record_attachment_required: 'Wymagany załącznik protokołu ubezpieczenia',
        please_upload_the_insurance_record_attachment: 'Prześlij załącznik protokołu ubezpieczenia',
        please_upload_the_diagnostic_record_attachment: 'Prześlij historię diagnostyczną',
        please_upload_site_photos: 'Prześlij zdjęcia kolizji',
    },
    // 土耳其
    trTR: {
        documentType: 'Belge türü',
        vehicleType: 'Araç tipi',
        dealerInformation: 'Satış Bilgisi',
        reportType: 'Dosya tipi',
        dealerContact: 'Bayi  İletişimi',
        contact: 'Kontakt #',
        customer_information: 'Müşteril bilgisi',
        occupation: 'Mesleği',
        vehicleInformation: 'Araç bilgisi',
        mileage: 'Mileage (/km)',
        licensePlate: 'Plaka',
        platform: 'Platform',
        offLineDate: 'Devre-tışı tarih',
        vehicleUse: 'Araç kullanımı',
        refited: 'Refited',
        insuranceSituation: 'Sigorta durumu',
        nameplateNo: 'İsim Tablosu Numarası',
        purchaseDate: 'Alış tarihi',
        accidentInformation: 'Kaza bilgisi',
        timeOfAccident: 'Kaza zamanı',
        placeOfAccident: 'Kaza yeri',
        roadConditions: 'Yol koşulları',
        pavementType: 'Yol kaplama durumu',
        weather: 'Hava',
        vehicleCondition: 'Araç durumu',
        vehicleOfTheAccident: 'Kaza zamanında araba bilgileri',
        vehicleCollisionPosition: 'Araç çarpma pozisyonu',
        vehicleRunningStatus: 'Araç çalışma durumu',
        ownSpeed: 'Araç hızı',
        vehicleSpeedOfTheOtherSide: 'Diğer tarafın araba hızı',
        personnelInsideTheVehicle: 'Arabadaki kişi',
        numberOfPeopleInTheCar: 'Arabadaki insanların sayısı',
        personalInjury: 'Kişisel yaralanmalar',
        distributionOfPersonnelInTheVehicle: 'Arabadaki personel dağıtımı',
        descriptionOfPersonalInjury: 'Kişisel yaralanmanın açıklaması',
        airbagDeployment: 'Hava yastığı açılma durumu',
        safetyBeltWearing: 'emniyet kemeri takılma durumu',
        brakeBeforeTheAccident: 'Kazadan önce fren.',
        turnBeforeTheIncident: 'Olay öncesi dönüş',
        whenCorrosionOccurs: 'Korozyon oluştuğunda',
        parkingTimeHours: 'Park zamanı (saat)',
        parkingTimeMinutes: 'Park zamanı (dakika)',
        drivingHours: 'Sürüş Süresi (saat)',
        drivingMinutes: 'Sürüş Süresi (dakika)',
        drivingDistance: 'Sürüş mesafesi',
        drivingSpeed: 'Sürücü hızı',
        vehicleState: 'Araç durumu',
        fireFightingOrNot: 'Yangın söndürme işlemi oldu mu?',
        numberOfInjured: 'Yaralı sayısı',
        deathToll: 'Ölü sayısı',
        vehicleHelp: 'Araç yardımı',
        vehiclePassingAccident: 'Araç kazası',
        pastAccidents: 'Geçmiş kazalar',
        isTheWarningLampOnBeforeTheEvent: 'Kaza öncesi uyarı lambası yandı mı?',
        specificIconContent: 'Belirli simge içeriği',
        didYouSmellFuelBeforeTheAccident: 'Kazadan önce yakıt kokuyordun mu?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Kazadan önce normal bir vibracyon hissettin mi?',
        abnormalSoundZone: 'Normal ses bölgesi',
        didYouHearAnyNoiseBeforeTheAccident: 'Kazadan önce bir ses duydun mu?',
        noiseDescription: 'Ses Açıklaması',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Kaza gerçekleşmeden önce araçtan duman geliyormuydu?',
        otherAreas: 'Diğer bölgeler',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Sigorta şirketinin bir rapor düzenledi mi?',
        whetherTheAuthorityIssuesTheCertificate: 'Otoritenin bir rapor düzenledi mi?',
        isVDSReportAvailable: 'VDS raporu mebvcut mu?',
        accidentProcess: 'Olay süreci',
        accidentProcessPlaceholder:
            'XXXX\' tarafından rapor edildi. \n' +
            'XX/XX/20XX\'de yaklaşık saat XXXX\'de, parti XXXX, güneyden kuzeye doğru ulusal otoyol üzerinde seyrederken,  XXXXXX plalalı  1.5/AT model bir araç sürüyordu (içerisindeki ve bir sürücü olan tek kişi var). XX Köyü, XX Şehir, XX Şehir, XX Şehir, XXX ülkesinden geçerken, aracın sol iç tarafından beyaz bir duman geldiği tespit edildi.',
        accessoryMaterials: 'Ekler',
        bulkDownload: 'Toplu indirme',
        materialUpload: 'Materiyal Yükleme',
        userReadmeAttachment: 'Kullanıcı rapor ekleri',
        sitePhotos: 'Olay yeri fotoğrafları',
        fireAccidentIdentificationLetter: 'Yangın kazası  doğrulaması',
        insuranceRecordAttachment: 'Sigorta kayıt ekleri',
        diagnosticRecords: 'Arızacılık geçmişi',
        temperature: 'Sıcaklık',
        please_select_the_reporting_type: 'Lütfen rapor türünü seçin',
        fire_accident_identification_letter_required: 'Yangın Kazası Tanımlama Raporu Gerekli',
        please_upload_the_fire_accident_identification_letter:
            'Lütfen Yangın Kazası Tanımlama Raporunu yükleyin',
        insurance_record_attachment_required: 'Sigorta Rapor Ekleri gerekli',
        please_upload_the_insurance_record_attachment: 'Sigorta Rapor Eklerini yükleyin.',
        please_upload_the_diagnostic_record_attachment: 'Arızacılık kayıtları eklerini yükleyin',
        please_upload_site_photos: 'Lütfen olay yeri fotoğraflarını yükleyin',
    },
    // 捷克语
    csCZ: {
        documentType: 'Typ dokumentu',
        vehicleType: 'Typ vozidla',
        dealerInformation: 'Informace o dealerovi',
        reportType: 'Typ případu',
        dealerContact: 'Kontakt na prodejce',
        contact: 'Kontakt #',
        customer_information: 'Informace o zákazníkovi',
        occupation: 'obsazení',
        vehicleInformation: 'Informace o vozidle',
        mileage: 'Najeto (/km)',
        licensePlate: 'Poznávací značka #',
        platform: 'Platforma',
        offLineDate: 'Datum off-line',
        vehicleUse: 'Používání vozidla',
        refited: 'Repasované',
        insuranceSituation: 'Pojistná situace',
        nameplateNo: 'Výrobní štítek č.',
        purchaseDate: 'Datum nákupu',
        accidentInformation: 'Informace o nehodě',
        timeOfAccident: 'Čas nehody',
        placeOfAccident: 'Místo nehody',
        roadConditions: 'Stav vozovky',
        pavementType: 'Typ povrchu',
        weather: 'Počasí',
        vehicleCondition: 'Stav vozidla',
        vehicleOfTheAccident: 'Informace o vozidle v době nehody',
        vehicleCollisionPosition: 'Poloha vozidla při nehodě',
        vehicleRunningStatus: 'Stav vozidla',
        ownSpeed: 'Vlastní rychlost',
        vehicleSpeedOfTheOtherSide: 'Rychlost protijedoucího vozidla',
        personnelInsideTheVehicle: 'Osoby uvnitř vozidla',
        numberOfPeopleInTheCar: 'Počet lidí ve vozidle',
        personalInjury: 'Újma na zdraví',
        distributionOfPersonnelInTheVehicle: 'Rozložení osob ve vozidle',
        descriptionOfPersonalInjury: 'Popis poranění osob',
        airbagDeployment: 'Aktivace modulu airbagu',
        safetyBeltWearing: 'Použití bezpečnostního pásu',
        brakeBeforeTheAccident: 'Brzdění před nehodou',
        turnBeforeTheIncident: 'Otáčení před nehodou',
        whenCorrosionOccurs: 'Když dojde ke korozi',
        parkingTimeHours: 'Doba parkování (hodiny)',
        parkingTimeMinutes: 'Doba parkování (minuty)',
        drivingHours: 'Doba jízdy hodiny',
        drivingMinutes: 'Doba jízdy minuty',
        drivingDistance: 'Ujetá vzdálenost',
        drivingSpeed: 'Rychlost jízdy',
        vehicleState: 'Stav vozidla',
        fireFightingOrNot: 'Hašení požáru nebo ne',
        numberOfInjured: 'Počet poraněných',
        deathToll: 'Počet obětí',
        vehicleHelp: 'Pomoc vozidla',
        vehiclePassingAccident: 'Projíždějícího vozidla kolem nehody',
        pastAccidents: 'Předchozí nehody',
        isTheWarningLampOnBeforeTheEvent: 'Svítila výstražná kontrolka před událostí',
        specificIconContent: 'Konkrétní obsah ikony',
        didYouSmellFuelBeforeTheAccident: 'Bylo před nehodou cítit palivo?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Cítili jste před nehodou nějaké neobvyklé vibrace?',
        abnormalSoundZone: 'Zóna s abnormálním hlukem',
        didYouHearAnyNoiseBeforeTheAccident: 'Slyšeli jste před nehodou nějaký hluk?',
        noiseDescription: 'Popis hluku',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Místo, kde se z vozidla před nehodou začalo kouřit',
        otherAreas: 'Ostatní oblasti',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Vydala pojišťovna osvědčení',
        whetherTheAuthorityIssuesTheCertificate: 'Vydala autorita osvědčení',
        isVDSReportAvailable: 'Je k dispozici report VDS',
        accidentProcess: 'Proces nehody',
        accidentProcessPlaceholder:
            'Reported by_XXXX\'s paraphrase.\n' +
            'Dne XX.XX.20XX kolem XXhod. řídil účastník nehody XXXX vozidlo značky Roewe RX50 1.5/AT s SPZ XXXXXX směrem na sever po státní silnici (ve vozidle byla pouze jedna osoba, řidič). Když dojel na úsek silnice v obci XX, okrese XX, městě XX, provincii XX, zjistil, že se z levé strany kabiny řidiče kouří.',
        accessoryMaterials: 'Příloha',
        bulkDownload: 'Hromadné stahování',
        materialUpload: 'Nahrání materiálů',
        userReadmeAttachment: 'Příloha zprávy uživatele',
        sitePhotos: 'Fotografie z místa události',
        fireAccidentIdentificationLetter: 'Potvrzení požáru při nehodě',
        insuranceRecordAttachment: 'Příloha záznamu o pojištění',
        diagnosticRecords: 'Historie diagnostiky',
        temperature: 'Teplota',
        please_select_the_reporting_type: 'Vyberte typ hlášení',
        fire_accident_identification_letter_required: 'Požadováno potvrzení o požáru',
        please_upload_the_fire_accident_identification_letter: 'Nahrajte prosím potvrzení o požáru',
        insurance_record_attachment_required: 'Povinná příloha záznamu o pojištění',
        please_upload_the_insurance_record_attachment:
            'Nahrajte prosím přílohu záznamu o pojištění',
        please_upload_the_diagnostic_record_attachment:
            'Nahrajte prosím přílohu diagnostického záznamu',
        please_upload_site_photos: 'Nahrajte prosím fotografie z místa',
    },
    // 匈牙利语
    huHU: {
        documentType: 'Dokumentumtípus',
        vehicleType: 'Járműtípus',
        dealerInformation: 'Kereskedői információ',
        reportType: 'Eset típusa',
        dealerContact: 'Kereskedői kapcsolattartó',
        contact: 'Kapcsolattartási sz.',
        customer_information: 'Ügyfélinformáció',
        occupation: 'Foglalkozás',
        vehicleInformation: 'Járműinformáció',
        mileage: 'Futásteljesítmény (km)',
        licensePlate: 'Rendszám',
        platform: 'Platform',
        offLineDate: 'Offline dátum',
        vehicleUse: 'Járműhasználat',
        refited: 'Átalakítás',
        insuranceSituation: 'Biztosítási állapot',
        nameplateNo: 'Névtábla sz.',
        purchaseDate: 'Vásárlás dátuma',
        accidentInformation: 'Baleseti információ',
        timeOfAccident: 'Baleset ideje',
        placeOfAccident: 'Baleset helye',
        roadConditions: 'Útviszonyok',
        pavementType: 'Útburkolat típusa',
        weather: 'Időjárás',
        vehicleCondition: 'Járműállapot',
        vehicleOfTheAccident: 'Járműinformáció a baleset időpontjában',
        vehicleCollisionPosition: 'Jármű ütközésének helyzete',
        vehicleRunningStatus: 'Jármű menetállapota',
        ownSpeed: 'Saját sebesség',
        vehicleSpeedOfTheOtherSide: 'Másik oldali járműsebesség',
        personnelInsideTheVehicle: 'Személyek a járműben',
        numberOfPeopleInTheCar: 'Autóban lévő személyek',
        personalInjury: 'Személyi sérülés',
        distributionOfPersonnelInTheVehicle: 'Személyek eloszlása a járműben',
        descriptionOfPersonalInjury: 'Személyi sérülés leírása',
        airbagDeployment: 'Légzsák felfúvódása',
        safetyBeltWearing: 'Biztonsági öv viselete',
        brakeBeforeTheAccident: 'Fékezés a baleset előtt',
        turnBeforeTheIncident: 'Kanyarodás a baleset előtt',
        whenCorrosionOccurs: 'Amikor korrózió történik',
        parkingTimeHours: 'Parkolási idő (óra)',
        parkingTimeMinutes: 'Parkolási idő (perc)',
        drivingHours: 'Haladási óra',
        drivingMinutes: 'Haladási perc',
        drivingDistance: 'Haladási távolság',
        drivingSpeed: 'Haladási sebesség',
        vehicleState: 'Járműállapot',
        fireFightingOrNot: 'Tűzoltóság volt-e',
        numberOfInjured: 'Sérültek száma',
        deathToll: 'Elhunytak száma',
        vehicleHelp: 'Segítség a járműnek',
        vehiclePassingAccident: 'Elhaladó jármű balesete',
        pastAccidents: 'Múltbéli balesetek',
        isTheWarningLampOnBeforeTheEvent: 'Világított-e figyelmeztető lámpa az esemény előtt',
        specificIconContent: 'Specifikus ikon tartalma',
        didYouSmellFuelBeforeTheAccident: 'Érezte-e üzemanyag szagát a baleset előtt',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Érzett-e rendellenes vibrációt a baleset előtt',
        abnormalSoundZone: 'Rendellenes hang területe',
        didYouHearAnyNoiseBeforeTheAccident: 'Hallott-e rendellenes zajt a baleset előtt',
        noiseDescription: 'Zaj leírása',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'A hely, ahol a jármű füstölni kezdett, mielőtt megtörtént a baleset',
        otherAreas: 'Egyéb területek',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Adott-e ki tanúsítványt a biztosítótársaság',
        whetherTheAuthorityIssuesTheCertificate: 'Adott-e ki tanúsítványt hatóság',
        isVDSReportAvailable: 'Van-e elérhető VDS jelentés',
        accidentProcess: 'Baleset lefolyása',
        accidentProcessPlaceholder:
            '_ által jelentett. XXXX elmondása.\n' +
            '20XX/XX/XX. délelőtt XX óra körül XXXX az XXXXXX rendszámú járművet vezette Roewe RX50 1.5/AT felé az autópálya mentén délről északra (egy utas és egy járművezető tartózkodott a járműben). Amikor az XX falu, XX város, XX megye, XXX tartomány felé haladt, azt észlelte, hogy fehér füst száll fel a műszerfal bal oldalából.',
        accessoryMaterials: 'Csatolmány',
        bulkDownload: 'Kötegelt letöltés',
        materialUpload: 'Anyag feltöltése',
        userReadmeAttachment: 'Felhasználói jelentés csatolása',
        sitePhotos: 'Helyszíni fényképek',
        fireAccidentIdentificationLetter: 'Tűzeset megerősítése',
        insuranceRecordAttachment: 'Baleseti jegyzőkönyv csatolása',
        diagnosticRecords: 'Diagnosztikai előzmények',
        temperature: 'Hőmérséklet',
        please_select_the_reporting_type: 'Válassza ki a jelentéstípust',
        fire_accident_identification_letter_required: 'Tűzesetet azonosító levél szükséges',
        please_upload_the_fire_accident_identification_letter:
            'Töltse fel a tűzesetet azonosító levelet',
        insurance_record_attachment_required: 'Biztosítási jegyzőkönyv csatolása szükséges',
        please_upload_the_insurance_record_attachment:
            'Töltse fel csatolmányként a biztosítási jegyzőkönyvet',
        please_upload_the_diagnostic_record_attachment:
            'Töltse fel csatolmányként a diagnosztikai jegyzőkönyvet',
        please_upload_site_photos: 'Töltse fel a helyszíni fényképeket',
    },
    // 俄罗斯语
    ruRU: {
        documentType: 'Тип документа',
        vehicleType: 'Тип транспортного средства',
        dealerInformation: 'Информация о дилере',
        reportType: 'Тип отчета',
        dealerContact: 'Контактное лицо дилера',
        contact: 'Контактный телефон',
        customer_information: 'Информация о клиенте',
        occupation: 'Профессия',
        vehicleInformation: 'Информация о транспортном средстве',
        mileage: 'Пробег / км',
        licensePlate: 'Номерной знак',
        platform: 'Платформа модели',
        offLineDate: 'Дата снятия с эксплуатации',
        vehicleUse: 'Назначение транспортного средства',
        refited: 'Модификации или изменения',
        insuranceSituation: 'Страховая ситуация',
        nameplateNo: 'Номер на табличке',
        purchaseDate: 'Дата покупки',
        accidentInformation: 'Информация об аварии',
        timeOfAccident: 'Дата и время аварии',
        placeOfAccident: 'Место происшествия',
        roadConditions: 'Состояние дороги',
        pavementType: 'Тип покрытия',
        weather: 'Погода',
        vehicleCondition: 'Состояние транспортного средства',
        vehicleOfTheAccident: 'Информация о транспортном средстве в момент происшествия',
        vehicleCollisionPosition: 'Место столкновения транспортного средства',
        vehicleRunningStatus: 'Состояние транспортного средства во время движения',
        ownSpeed: 'Скорость вашего автомобиля',
        vehicleSpeedOfTheOtherSide: 'Скорость другого автомобиля',
        personnelInsideTheVehicle: 'Состояние людей в машине в момент происшествия',
        numberOfPeopleInTheCar: 'Количество людей в машине',
        personalInjury: 'Состояние пострадавших',
        distributionOfPersonnelInTheVehicle: 'Место сидения пострадавших',
        descriptionOfPersonalInjury: 'Описание травм пострадавших',
        airbagDeployment: 'Состояние подушек безопасности',
        safetyBeltWearing: 'Состояние ремней безопасности',
        brakeBeforeTheAccident: 'Торможение перед происшествием',
        turnBeforeTheIncident: 'Маневрирование перед происшествием',
        whenCorrosionOccurs: 'Когда произошло коррозия',
        parkingTimeHours: 'Время парковки (часы)',
        parkingTimeMinutes: 'Время парковки (минуты)',
        drivingHours: 'Часы вождения',
        drivingMinutes: 'Минуты вождения',
        drivingDistance: 'Расстояние вождения',
        drivingSpeed: 'Скорость вождения',
        vehicleState: 'Состояние транспортного средства во время происшествия',
        fireFightingOrNot: 'Использовалась ли противопожарная служба',
        numberOfInjured: 'Количество пострадавших',
        deathToll: 'Количество погибших',
        vehicleHelp: 'Состояние помощи автомобилю',
        vehiclePassingAccident: 'Предыдущие аварии автомобиля',
        pastAccidents: 'Предыдущие аварии',
        isTheWarningLampOnBeforeTheEvent:
            'Был ли включен индикатор предупреждения перед происшествием',
        specificIconContent: 'Содержимое специфической иконки',
        didYouSmellFuelBeforeTheAccident: 'Почувствовали ли вы запах топлива перед происшествием?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Ощущали ли вы необычную вибрацию перед происшествием?',
        abnormalSoundZone: 'Место шумов',
        didYouHearAnyNoiseBeforeTheAccident: 'Слышали ли вы шум перед происшествием?',
        noiseDescription: 'Описание шума',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Место появления дыма перед происшествием',
        otherAreas: 'Другие зоны',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Выдала ли страховая компания сертификат?',
        whetherTheAuthorityIssuesTheCertificate: 'Выдала ли авторитетная организация сертификат?',
        isVDSReportAvailable: 'Может ли быть предоставлен отчет VDS?',
        accidentProcess: 'Ход происшествия',
        accidentProcessPlaceholder:
            'Передача информации от XXXX\n' +
            '20XX год, XX месяц, XX число, примерно в XX часов XX минут, водитель XXXX управлял автомобилем марки Roewe RX50 1.5/AT с номерным знаком XXXXXX, который двигался по национальной дороге в направлении с юга на север (в автомобиле был только один человек — водитель). Когда автомобиль двигался по участку дороги в XXX провинции, XX городе, XX уезде, XX посёлке, XX деревне, в левом переднем отсеке автомобиля появилась белая дымка.',
        accessoryMaterials: 'Прикрепленные материалы',
        bulkDownload: 'Пакетная загрузка',
        materialUpload: 'Загрузка материалов',
        userReadmeAttachment: 'Документы от пользователя',
        sitePhotos: 'Фотографии с места происшествия',
        fireAccidentIdentificationLetter: 'Сертификат о пожаре',
        insuranceRecordAttachment: 'Прикрепленные страховые записи',
        diagnosticRecords: 'Записи диагностики',
        temperature: 'Температура',
        please_select_the_reporting_type: 'Выберите тип отчета',
        fire_accident_identification_letter_required: 'Сертификат о пожаре обязателен',
        please_upload_the_fire_accident_identification_letter:
            'Пожалуйста, загрузите сертификат о пожаре',
        insurance_record_attachment_required: 'Прикрепленные страховые записи обязательны',
        please_upload_the_insurance_record_attachment:
            'Пожалуйста, загрузите прикрепленные страховые записи',
        please_upload_the_diagnostic_record_attachment: 'Пожалуйста, загрузите записи диагностики',
        please_upload_the_site_photos: 'Пожалуйста, загрузите фотографии с места происшествия',
    },
    arSA: {
        documentType: 'نوع المستند',
        vehicleType: 'نوع المركبة',
        dealerInformation: 'معلومات الوكيل',
        reportType: 'نوع الإبلاغ',
        dealerContact: 'جهة اتصال الوكيل',
        contact: 'رقم الاتصال',
        customer_information: 'معلومات العميل',
        occupation: 'المهنة',
        vehicleInformation: 'معلومات المركبة',
        mileage: 'عدد الكيلومترات المقطوعة (كم)',
        licensePlate: 'رقم لوحة التسجيل',
        platform: 'منصة الطراز',
        offLineDate: 'تاريخ الخروج من خط الإنتاج',
        vehicleUse: 'غرض استخدام المركبة',
        refited: 'هل تم إجراء تعديلات أو تركيبات إضافية؟',
        insuranceSituation: 'حالة التأمين',
        nameplateNo: 'رقم اللوحة التعريفية',
        purchaseDate: 'تاريخ الشراء',
        accidentInformation: 'معلومات الحادث',
        timeOfAccident: 'وقت وقوع الحادث',
        placeOfAccident: 'مكان وقوع الحادث',
        roadConditions: 'حالة الطريق',
        pavementType: 'نوع سطح الطريق',
        weather: 'الطقس',
        vehicleCondition: 'حالة المركبة',
        vehicleOfTheAccident: 'معلومات المركبة وقت وقوع الحادث',
        vehicleCollisionPosition: 'موضع تصادم المركبة',
        vehicleRunningStatus: 'حالة سير المركبة',
        ownSpeed: 'سرعة المركبة الخاصة',
        vehicleSpeedOfTheOtherSide: 'سرعة المركبة الأخرى',
        personnelInsideTheVehicle: 'حالة الأشخاص داخل المركبة وقت الحادث',
        numberOfPeopleInTheCar: 'عدد الأشخاص في المركبة',
        personalInjury: 'إصابات الأشخاص',
        distributionOfPersonnelInTheVehicle: 'مواقع الجلوس للأشخاص المصابين',
        descriptionOfPersonalInjury: 'وصف إصابات الأشخاص',
        airbagDeployment: 'حالة انتشار الوسائد الهوائية',
        safetyBeltWearing: 'ارتداء حزام الأمان',
        brakeBeforeTheAccident: 'الفرملة قبل الحادث',
        turnBeforeTheIncident: 'التوجيه قبل الحادث',
        whenCorrosionOccurs: 'متى حدث التآكل؟',
        parkingTimeHours: 'وقت الوقوف (ساعات)',
        parkingTimeMinutes: 'وقت الوقوف (دقائق)',
        drivingHours: 'ساعات القيادة',
        drivingMinutes: 'دقائق القيادة',
        drivingDistance: 'مسافة القيادة',
        drivingSpeed: 'سرعة القيادة',
        vehicleState: 'حالة المركبة وقت الحادث',
        fireFightingOrNot: 'هل تم إخماد الحريق بواسطة فرق الإطفاء؟',
        numberOfInjured: 'عدد المصابين',
        deathToll: 'عدد الوفيات',
        vehicleHelp: 'طلب مساعدة للمركبة',
        vehiclePassingAccident: 'حوادث سابقة للمركبة',
        pastAccidents: 'الحوادث السابقة',
        isTheWarningLampOnBeforeTheEvent: 'هل كانت لمبة التحذير مشتعلة قبل الحدث؟',
        specificIconContent: 'محتوى الرمز المحدد',
        didYouSmellFuelBeforeTheAccident: 'هل شممت رائحة وقود قبل الحادث؟',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident: 'هل شعرت باهتزاز غير طبيعي قبل الحادث؟',
        abnormalSoundZone: 'منطقة الصوت غير الطبيعي',
        didYouHearAnyNoiseBeforeTheAccident: 'هل سمعت أي ضوضاء قبل الحادث؟',
        noiseDescription: 'وصف الضوضاء',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'مكان انبعاث الدخان من المركبة قبل الحادث',
        otherAreas: 'مناطق أخرى',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'هل أصدرت شركة التأمين شهادة؟',
        whetherTheAuthorityIssuesTheCertificate: 'هل أصدرت الجهة المختصة شهادة؟',
        isVDSReportAvailable: 'هل يمكن الحصول على تقرير VDS؟',
        accidentProcess: 'وصف الحادث',
        accidentProcessPlaceholder:
            'رواية المراسل _XXXX.\n' +
            'حوالي الساعة XX:XX صباح يوم XX/XX/20XX، كان الشخص XXXX يقود مركبة تحمل لوحة رقم XXXXXX من طراز رونغوي RX50 1.5/AT، متجهاً من الجنوب إلى الشمال على الطريق الوطني (كان يوجد شخص واحد فقط في المركبة، وهو السائق). وعند وصوله إلى قسم XX في بلدة XX بمقاطعة XX بمدينة XX، لاحظ دخاناً أبيض يتصاعد من كابينة القيادة اليسرى.',
        accessoryMaterials: 'المرفقات',
        bulkDownload: 'تنزيل جماعي',
        materialUpload: 'تحميل المواد',
        userReadmeAttachment: 'مرفق وصف المستخدم',
        sitePhotos: 'صور الموقع',
        fireAccidentIdentificationLetter: 'وثيقة تحديد حادث الحريق',
        insuranceRecordAttachment: 'مرفق سجل التأمين',
        diagnosticRecords: 'سجلات التشخيص',
        temperature: 'درجة الحرارة',
        please_select_the_reporting_type: 'يرجى اختيار نوع الإبلاغ',
        fire_accident_identification_letter_required: 'وثيقة تحديد حادث الحريق إلزامية',
        please_upload_the_fire_accident_identification_letter: 'يرجى تحميل وثيقة تحديد حادث الحريق',
        insurance_record_attachment_required: 'مرفق سجل التأمين إلزامي',
        please_upload_the_insurance_record_attachment: 'يرجى تحميل مرفق سجل التأمين',
        please_upload_the_diagnostic_record_attachment: 'يرجى تحميل مرفق سجل التشخيص',
        please_upload_site_photos: 'يرجى تحميل صور الموقع',
    },

    // 保加利亚语
    bgBG: {
        documentType: 'Тип на документа',
        vehicleType: 'Тип превозно средство',
        dealerInformation: 'Информация за дилъра',
        reportType: 'Тип доклад',
        dealerContact: 'Контактно лице на дилъра',
        contact: 'Телефон за връзка',
        customer_information: 'Информация за клиента',
        occupation: 'Професия',
        vehicleInformation: 'Информация за превозното средство',
        mileage: 'Пробег (км)',
        licensePlate: 'Регистрационен номер',
        platform: 'Платформа на модела',
        offLineDate: 'Дата на излизане от производствена линия',
        vehicleUse: 'Назначение на превозното средство',
        refited: 'Има ли допълнителни модификации?',
        insuranceSituation: 'Страховка',
        nameplateNo: 'Номер на табелката',
        purchaseDate: 'Дата на закупуване',
        accidentInformation: 'Информация за инцидента',
        timeOfAccident: 'Време на инцидента',
        placeOfAccident: 'Място на инцидента',
        roadConditions: 'Състояние на пътя',
        pavementType: 'Тип на настилката',
        weather: 'Времето',
        vehicleCondition: 'Състояние на превозното средство',
        vehicleOfTheAccident: 'Информация за превозното средство по време на инцидента',
        vehicleCollisionPosition: 'Място на сблъсък',
        vehicleRunningStatus: 'Състояние при движение',
        ownSpeed: 'Скорост на собственото превозно средство',
        vehicleSpeedOfTheOtherSide: 'Скорост на другото превозно средство',
        personnelInsideTheVehicle: 'Състояние на хората в превозното средство',
        numberOfPeopleInTheCar: 'Брой хора в колата',
        personalInjury: 'Лични наранявания',
        distributionOfPersonnelInTheVehicle: 'Позиции на наранените лица',
        descriptionOfPersonalInjury: 'Описание на нараняванията',
        airbagDeployment: 'Активиране на въздушна възглавница',
        safetyBeltWearing: 'Носене на колан',
        brakeBeforeTheAccident: 'Спиране преди инцидента',
        turnBeforeTheIncident: 'Завиване преди инцидента',
        whenCorrosionOccurs: 'Кога се появява корозия?',
        parkingTimeHours: 'Време на паркиране (часове)',
        parkingTimeMinutes: 'Време на паркиране (минути)',
        drivingHours: 'Часове шофиране',
        drivingMinutes: 'Минути шофиране',
        drivingDistance: 'Изминато разстояние',
        drivingSpeed: 'Скорост на шофиране',
        vehicleState: 'Състояние на превозното средство по време на инцидента',
        fireFightingOrNot: 'Интервенция на пожарникари?',
        numberOfInjured: 'Брой ранени',
        deathToll: 'Брой загинали',
        vehicleHelp: 'Помощ за превозното средство',
        vehiclePassingAccident: 'Предишни инциденти с превозното средство',
        pastAccidents: 'Предишни инциденти',
        isTheWarningLampOnBeforeTheEvent: 'Светеше ли предупредителна лампа преди инцидента?',
        specificIconContent: 'Съдържание на конкретен иконен символ',
        didYouSmellFuelBeforeTheAccident: 'Усетихте ли миризма на гориво преди инцидента?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Усетихте ли необичайни вибрации преди инцидента?',
        abnormalSoundZone: 'Зона на необичайни звуци',
        didYouHearAnyNoiseBeforeTheAccident: 'Чухте ли шум преди инцидента?',
        noiseDescription: 'Описание на шума',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Място, от което превозното средство започна да пуши преди инцидента',
        otherAreas: 'Други области',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Издаде ли застрахователят сертификат?',
        whetherTheAuthorityIssuesTheCertificate: 'Издаде ли компетентният орган сертификат?',
        isVDSReportAvailable: 'Наличен ли е VDS доклад?',
        accidentProcess: 'Ход на инцидента',
        accidentProcessPlaceholder:
            'Относно: Отчет на подателя _XXXX.\n' +
            'Около XX:XX ч. на XX/XX/20XX г., лицето XXXX караше превозно средство с регистрационен номер XXXXXX, модел Roewe RX50 1.5/AT, движещо се по национален път от юг на север (в колата имаше един човек – шофьорът). При достигане до участък XX в село XX, област XX, град XX, забеляза бял дим в лявата кабина.',
        accessoryMaterials: 'Прикачени материали',
        bulkDownload: 'Масово изтегляне',
        materialUpload: 'Качване на материали',
        userReadmeAttachment: 'Прикачен файл с описание от потребителя',
        sitePhotos: 'Снимки от мястото',
        fireAccidentIdentificationLetter: 'Удостоверение за пожарен инцидент',
        insuranceRecordAttachment: 'Прикачен файл със застрахователен запис',
        diagnosticRecords: 'Диагностични записи',
        temperature: 'Температура',
        please_select_the_reporting_type: 'Моля, изберете тип на доклада',
        fire_accident_identification_letter_required:
            'Удостоверението за пожарен инцидент е задължително',
        please_upload_the_fire_accident_identification_letter:
            'Моля, качете удостоверението за пожарен инцидент',
        insurance_record_attachment_required:
            'Прикаченият файл със застрахователния запис е задължителен',
        please_upload_the_insurance_record_attachment:
            'Моля, качете прикачения файл със застрахователния запис',
        please_upload_the_diagnostic_record_attachment:
            'Моля, качете прикачения файл с диагностичния запис',
        please_upload_site_photos: 'Моля, качете снимки от мястото',
    },

    // 丹麦语
    daDK: {
        documentType: 'Dokumenttype',
        vehicleType: 'Køretøjstype',
        dealerInformation: 'Forhandlerinformation',
        reportType: 'Rapporttype',
        dealerContact: 'Forhandlerkontakt',
        contact: 'Kontakttelefon',
        customer_information: 'Kundeoplysninger',
        occupation: 'Erhverv',
        vehicleInformation: 'Køretøjsinformation',
        mileage: 'Kilometerstand (km)',
        licensePlate: 'Nummerplade',
        platform: 'Modelplatform',
        offLineDate: 'Produktionsafslutningsdato',
        vehicleUse: 'Køretøjets anvendelse',
        refited: 'Er der foretaget ændringer eller tilpasninger?',
        insuranceSituation: 'Forsikringssituation',
        nameplateNo: 'Mærkepladenummer',
        purchaseDate: 'Købsdato',
        accidentInformation: 'Uheldsoplysninger',
        timeOfAccident: 'Tidspunkt for uheldet',
        placeOfAccident: 'Sted for uheldet',
        roadConditions: 'Vejforhold',
        pavementType: 'Belægningstype',
        weather: 'Vejr',
        vehicleCondition: 'Køretøjets tilstand',
        vehicleOfTheAccident: 'Køretøjsoplysninger ved uheldet',
        vehicleCollisionPosition: 'Kollisionens placering på køretøjet',
        vehicleRunningStatus: 'Køretøjets kørselsstatus',
        ownSpeed: 'Egen hastighed',
        vehicleSpeedOfTheOtherSide: 'Modpartens hastighed',
        personnelInsideTheVehicle: 'Personer i køretøjet under uheldet',
        numberOfPeopleInTheCar: 'Antal personer i bilen',
        personalInjury: 'Personskader',
        distributionOfPersonnelInTheVehicle: 'Placering af skadede personer',
        descriptionOfPersonalInjury: 'Beskrivelse af personskader',
        airbagDeployment: 'Airbag-udløsning',
        safetyBeltWearing: 'Sikkerhedsseler båret',
        brakeBeforeTheAccident: 'Bremsning før uheldet',
        turnBeforeTheIncident: 'Sving før hændelsen',
        whenCorrosionOccurs: 'Hvornår opstod korrosion?',
        parkingTimeHours: 'Parkeringstid (timer)',
        parkingTimeMinutes: 'Parkeringstid (minutter)',
        drivingHours: 'Køretimer',
        drivingMinutes: 'Køretminutter',
        drivingDistance: 'Kørelængde',
        drivingSpeed: 'Kørehastighed',
        vehicleState: 'Køretøjets tilstand under uheldet',
        fireFightingOrNot: 'Slukket af brandvæsen?',
        numberOfInjured: 'Antal kvæstede',
        deathToll: 'Antal døde',
        vehicleHelp: 'Køretøjshjælp',
        vehiclePassingAccident: 'Tidligere uheld med køretøjet',
        pastAccidents: 'Tidligere uheld',
        isTheWarningLampOnBeforeTheEvent: 'Var advarselslampen tændt før hændelsen?',
        specificIconContent: 'Specifikt ikonindhold',
        didYouSmellFuelBeforeTheAccident: 'Lugtede du brændstof før uheldet?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Oplevede du unormal vibration før uheldet?',
        abnormalSoundZone: 'Område med unormal lyd',
        didYouHearAnyNoiseBeforeTheAccident: 'Hørte du støj før uheldet?',
        noiseDescription: 'Beskrivelse af støj',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Område hvor køretøjet rygede før uheldet',
        otherAreas: 'Andre områder',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Har forsikringsselskabet udstedt et certifikat?',
        whetherTheAuthorityIssuesTheCertificate: 'Har myndighederne udstedt et certifikat?',
        isVDSReportAvailable: 'Er VDS-rapport tilgængelig?',
        accidentProcess: 'Hændelsesforløb',
        accidentProcessPlaceholder:
            'Ifølge indberetter _XXXX.\n' +
            'Omkring kl. XX:XX den XX/XX/20XX kørte personen XXXX i et køretøj med nummerpladen XXXXXX, model Roewe RX50 1.5/AT, nordpå ad landevejen (kun én person i bilen – føreren). Ved ankomst til strækningen ved landsbyen XX i byen XX, provinsen XX, bemærkede han hvid røg fra venstre førerkabine.',
        accessoryMaterials: 'Vedhæftede materialer',
        bulkDownload: 'Masse-download',
        materialUpload: 'Upload materiale',
        userReadmeAttachment: 'Brugerbeskrivelse vedhæftet',
        sitePhotos: 'Stedfotos',
        fireAccidentIdentificationLetter: 'Brandhændelsesattest',
        insuranceRecordAttachment: 'Forsikringsjournal vedhæftet',
        diagnosticRecords: 'Diagnosejournaler',
        temperature: 'Temperatur',
        please_select_the_reporting_type: 'Vælg venligst rapporttype',
        fire_accident_identification_letter_required: 'Brandhændelsesattest er påkrævet',
        please_upload_the_fire_accident_identification_letter:
            'Upload venligst brandhændelsesattesten',
        insurance_record_attachment_required: 'Forsikringsjournal er påkrævet',
        please_upload_the_insurance_record_attachment: 'Upload venligst forsikringsjournalen',
        please_upload_the_diagnostic_record_attachment: 'Upload venligst diagnosejournalen',
        please_upload_site_photos: 'Upload venligst stedfotos',
    },

    // 芬兰语
    fiFI: {
        documentType: 'Asiakirjan tyyppi',
        vehicleType: 'Ajoneuvotyyppi',
        dealerInformation: 'Jälleenmyyjän tiedot',
        reportType: 'Ilmoituksen tyyppi',
        dealerContact: 'Jälleenmyyjän yhteyshenkilö',
        contact: 'Yhteystiedot',
        customer_information: 'Asiakkaan tiedot',
        occupation: 'Ammatti',
        vehicleInformation: 'Ajoneuvon tiedot',
        mileage: 'Ajokilometrit (km)',
        licensePlate: 'Rekisterinumero',
        platform: 'Mallialusta',
        offLineDate: 'Tuotantolinjan poistopäivämäärä',
        vehicleUse: 'Ajoneuvon käyttötarkoitus',
        refited: 'Onko ajoneuvoon tehty muutoksia tai lisävarusteita?',
        insuranceSituation: 'Vakuutustilanne',
        nameplateNo: 'Nimikyltin numero',
        purchaseDate: 'Ostopäivämäärä',
        accidentInformation: 'Onnettomuuden tiedot',
        timeOfAccident: 'Onnettomuuden aika',
        placeOfAccident: 'Onnettomuuden paikka',
        roadConditions: 'Tien kunto',
        pavementType: 'Pintamateriaali',
        weather: 'Sää',
        vehicleCondition: 'Ajoneuvon kunto',
        vehicleOfTheAccident: 'Ajoneuvon tiedot onnettomuushetkellä',
        vehicleCollisionPosition: 'Ajoneuvon törmäyskohta',
        vehicleRunningStatus: 'Ajoneuvon ajo-tila',
        ownSpeed: 'Oma nopeus',
        vehicleSpeedOfTheOtherSide: 'Toisen osapuolen nopeus',
        personnelInsideTheVehicle: 'Henkilöt ajoneuvossa onnettomuushetkellä',
        numberOfPeopleInTheCar: 'Henkilöiden määrä ajoneuvossa',
        personalInjury: 'Henkilövahingot',
        distributionOfPersonnelInTheVehicle: 'Vammautuneiden istumapaikat',
        descriptionOfPersonalInjury: 'Henkilövahinkojen kuvaus',
        airbagDeployment: 'Turvatyynyjen laukeaminen',
        safetyBeltWearing: 'Turvavyön käyttö',
        brakeBeforeTheAccident: 'Jarrutus ennen onnettomuutta',
        turnBeforeTheIncident: 'Ohjaus ennen tapahtumaa',
        whenCorrosionOccurs: 'Milloin ruostuminen ilmenee?',
        parkingTimeHours: 'Pysäköintiaika (tuntia)',
        parkingTimeMinutes: 'Pysäköintiaika (minuuttia)',
        drivingHours: 'Ajoaika (tuntia)',
        drivingMinutes: 'Ajoaika (minuuttia)',
        drivingDistance: 'Ajomatka',
        drivingSpeed: 'Ajonopeus',
        vehicleState: 'Ajoneuvon tila onnettomuushetkellä',
        fireFightingOrNot: 'Sammutettiinko palo paloautolla?',
        numberOfInjured: 'Loukkaantuneiden määrä',
        deathToll: 'Kuolleiden määrä',
        vehicleHelp: 'Ajoneuvon avun tarve',
        vehiclePassingAccident: 'Ajoneuvon aiemmat onnettomuudet',
        pastAccidents: 'Aiemmat onnettomuudet',
        isTheWarningLampOnBeforeTheEvent: 'Paloi varoituslamppu ennen tapahtumaa?',
        specificIconContent: 'Tietyn kuvakkeen sisältö',
        didYouSmellFuelBeforeTheAccident: 'Haistitko polttoainetta ennen onnettomuutta?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Tunsitko epänormaalia värinää ennen onnettomuutta?',
        abnormalSoundZone: 'Epänormaalin äänen alue',
        didYouHearAnyNoiseBeforeTheAccident: 'Kuulitko melua ennen onnettomuutta?',
        noiseDescription: 'Melun kuvaus',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Alue, josta ajoneuvo alkoi savuttaa ennen onnettomuutta',
        otherAreas: 'Muut alueet',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Onko vakuutusyhtiö antanut todisteen?',
        whetherTheAuthorityIssuesTheCertificate: 'Onko viranomainen antanut todisteen?',
        isVDSReportAvailable: 'Onko VDS-raportti saatavilla?',
        accidentProcess: 'Tapahtumankuvaus',
        accidentProcessPlaceholder:
            'Ilmoittajan _XXXX kertomus.\n' +
            'Noin klo XX:XX päivänä XX/XX/20XX henkilö XXXX oli ajamassa rekisterinumeroa XXXXXX olevaa Roewe RX50 1.5/AT -ajoneuvoa valtatietä etelästä pohjoiseen (ajoneuvossa vain yksi henkilö – kuljettaja). Saavuttuaan paikkaan XX kunnassa XX kaupungissa, XX maakunnassa, hän huomasi valkoista savua vasemmasta ohjaamosta.',
        accessoryMaterials: 'Liitteet',
        bulkDownload: 'Massalataus',
        materialUpload: 'Materiaalin lataus',
        userReadmeAttachment: 'Käyttäjän kuvausliite',
        sitePhotos: 'Paikkakuvat',
        fireAccidentIdentificationLetter: 'Tulipalotodistus',
        insuranceRecordAttachment: 'Vakuutustietoliite',
        diagnosticRecords: 'Diagnostiikkamerkinnät',
        temperature: 'Lämpötila',
        please_select_the_reporting_type: 'Valitse ilmoituksen tyyppi',
        fire_accident_identification_letter_required: 'Tulipalotodistus on pakollinen',
        please_upload_the_fire_accident_identification_letter: 'Lataa tulipalotodistus',
        insurance_record_attachment_required: 'Vakuutustietoliite on pakollinen',
        please_upload_the_insurance_record_attachment: 'Lataa vakuutustietoliite',
        please_upload_the_diagnostic_record_attachment: 'Lataa diagnostiikkamerkintöjen liite',
        please_upload_site_photos: 'Lataa paikkakuvat',
    },

    // 繁体中文（台湾）
    zhTW: {
        documentType: '單據類型',
        vehicleType: '車輛類型',
        dealerInformation: '經銷商資訊',
        reportType: '上報類型',
        dealerContact: '經銷商聯絡人',
        contact: '聯絡電話',
        customer_information: '客戶資訊',
        occupation: '職業',
        vehicleInformation: '車輛資訊',
        mileage: '行駛里程（公里）',
        licensePlate: '車牌號碼',
        platform: '車型平台',
        offLineDate: '下線日期',
        vehicleUse: '車輛用途',
        refited: '是否有加裝或改裝',
        insuranceSituation: '保險情況',
        nameplateNo: '銘牌編號',
        purchaseDate: '購買日期',
        accidentInformation: '事故資訊',
        timeOfAccident: '事故發生時間',
        placeOfAccident: '事故發生地點',
        roadConditions: '道路狀況',
        pavementType: '路面類型',
        weather: '天氣',
        vehicleCondition: '車輛狀況',
        vehicleOfTheAccident: '事故發生時車輛資訊',
        vehicleCollisionPosition: '車輛碰撞位置',
        vehicleRunningStatus: '車輛行駛狀態',
        ownSpeed: '己方車速',
        vehicleSpeedOfTheOtherSide: '對方車速',
        personnelInsideTheVehicle: '事發車內人員狀況',
        numberOfPeopleInTheCar: '車內人數',
        personalInjury: '人員受傷情況',
        distributionOfPersonnelInTheVehicle: '受傷人員所坐位置',
        descriptionOfPersonalInjury: '人員受傷情況描述',
        airbagDeployment: '氣囊展開情況',
        safetyBeltWearing: '安全帶佩戴情況',
        brakeBeforeTheAccident: '事發前剎車',
        turnBeforeTheIncident: '事發前轉向',
        whenCorrosionOccurs: '何時發生腐蝕',
        parkingTimeHours: '停車時間（小時）',
        parkingTimeMinutes: '停車時間（分鐘）',
        drivingHours: '駕駛小時',
        drivingMinutes: '駕駛分鐘',
        drivingDistance: '駕駛距離',
        drivingSpeed: '駕駛速度',
        vehicleState: '事故發生時車輛狀態',
        fireFightingOrNot: '是否消防救火',
        numberOfInjured: '受傷人數',
        deathToll: '死亡人數',
        vehicleHelp: '車輛求助情況',
        vehiclePassingAccident: '車輛過往事故',
        pastAccidents: '過往事故',
        isTheWarningLampOnBeforeTheEvent: '事件發生前警告燈是否亮起',
        specificIconContent: '特定圖示內容',
        didYouSmellFuelBeforeTheAccident: '事發前你聞到燃油味了嗎？',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident: '事發前有沒有感覺到異常震動？',
        abnormalSoundZone: '異響區域',
        didYouHearAnyNoiseBeforeTheAccident: '事發前你聽到什麼噪音了嗎？',
        noiseDescription: '噪音描述',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: '事發前車輛起煙位置',
        otherAreas: '其他區域',
        whetherTheInsuranceCompanyHasIssuedACertificate: '保險公司是否出具了證明？',
        whetherTheAuthorityIssuesTheCertificate: '權威部門是否出具證明？',
        isVDSReportAvailable: '是否可獲得 VDS 報告？',
        accidentProcess: '事發過程',
        accidentProcessPlaceholder:
            '提報人_XXXX 的轉述。\n' +
            '20XX 年 XX 月 XX 日凌晨 XX 點 XX 分左右，當事人 XXXX 駕駛車牌號為 XXXXXX 的榮威 RX50 1.5/AT 車輛，沿國道由南向北方向行駛（車內共一人，駕駛員一位）。當行駛至 XXX 省 XX 市 XX 縣 XX 鎮 XX 村路段處，發現左側駕駛艙內產生白煙。',
        accessoryMaterials: '附件材料',
        bulkDownload: '批次下載',
        materialUpload: '材料上傳',
        userReadmeAttachment: '用戶自述附件',
        sitePhotos: '現場照片',
        fireAccidentIdentificationLetter: '火災事故認定書',
        insuranceRecordAttachment: '保險記錄附件',
        diagnosticRecords: '診斷記錄',
        temperature: '溫度',
        please_select_the_reporting_type: '請選擇上報類型',
        fire_accident_identification_letter_required: '火災事故認定書為必填項',
        please_upload_the_fire_accident_identification_letter: '請上傳火災事故認定書',
        insurance_record_attachment_required: '保險記錄附件為必填項',
        please_upload_the_insurance_record_attachment: '請上傳保險記錄附件',
        please_upload_the_diagnostic_record_attachment: '請上傳診斷記錄附件',
        please_upload_site_photos: '請上傳現場照片',
    },

    // 克罗地亚语
    hrHR: {
        documentType: 'Vrsta dokumenta',
        vehicleType: 'Vrsta vozila',
        dealerInformation: 'Podaci o trgovcu',
        reportType: 'Vrsta prijave',
        dealerContact: 'Kontakt osoba trgovca',
        contact: 'Kontakt telefon',
        customer_information: 'Podaci o kupcu',
        occupation: 'Zanimanje',
        vehicleInformation: 'Podaci o vozilu',
        mileage: 'Prijeđeni kilometri (km)',
        licensePlate: 'Registracija',
        platform: 'Platforma modela',
        offLineDate: 'Datum izlaska s proizvodne trake',
        vehicleUse: 'Namjena vozila',
        refited: 'Postoje li dodatne preinake ili oprema?',
        insuranceSituation: 'Stanje osiguranja',
        nameplateNo: 'Broj natpisne pločice',
        purchaseDate: 'Datum kupnje',
        accidentInformation: 'Podaci o nesreći',
        timeOfAccident: 'Vrijeme nesreće',
        placeOfAccident: 'Mjesto nesreće',
        roadConditions: 'Stanje ceste',
        pavementType: 'Vrsta kolnika',
        weather: 'Vremenske prilike',
        vehicleCondition: 'Stanje vozila',
        vehicleOfTheAccident: 'Podaci o vozilu tijekom nesreće',
        vehicleCollisionPosition: 'Položaj sudara na vozilu',
        vehicleRunningStatus: 'Stanje vožnje vozila',
        ownSpeed: 'Vlastita brzina',
        vehicleSpeedOfTheOtherSide: 'Brzina druge strane',
        personnelInsideTheVehicle: 'Osoblje u vozilu tijekom nesreće',
        numberOfPeopleInTheCar: 'Broj osoba u vozilu',
        personalInjury: 'Oštećenja osoba',
        distributionOfPersonnelInTheVehicle: 'Pozicije ozlijeđenih osoba',
        descriptionOfPersonalInjury: 'Opis ozljeda osoba',
        airbagDeployment: 'Aktiviranje zračne jastuke',
        safetyBeltWearing: 'Nošenje sigurnosnog pojasa',
        brakeBeforeTheAccident: 'Kočenje prije nesreće',
        turnBeforeTheIncident: 'Skretanje prije incidenta',
        whenCorrosionOccurs: 'Kada se pojavljuje korozija?',
        parkingTimeHours: 'Vrijeme parkiranja (sati)',
        parkingTimeMinutes: 'Vrijeme parkiranja (minute)',
        drivingHours: 'Sati vožnje',
        drivingMinutes: 'Minute vožnje',
        drivingDistance: 'Udaljenost vožnje',
        drivingSpeed: 'Brzina vožnje',
        vehicleState: 'Stanje vozila tijekom nesreće',
        fireFightingOrNot: 'Je li vatrogasna služba intervenirala?',
        numberOfInjured: 'Broj ozlijeđenih',
        deathToll: 'Broj poginulih',
        vehicleHelp: 'Pomoć za vozilo',
        vehiclePassingAccident: 'Prethodne nesreće s vozilom',
        pastAccidents: 'Prethodne nesreće',
        isTheWarningLampOnBeforeTheEvent:
            'Je li upozoravajuće svjetlo bilo upaljeno prije događaja?',
        specificIconContent: 'Sadržaj određene ikone',
        didYouSmellFuelBeforeTheAccident: 'Jeste li mirisali gorivo prije nesreće?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Jeste li osjetili neobične vibracije prije nesreće?',
        abnormalSoundZone: 'Područje neobičnih zvukova',
        didYouHearAnyNoiseBeforeTheAccident: 'Jeste li čuli buku prije nesreće?',
        noiseDescription: 'Opis buke',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Područje s kojeg je vozilo pušilo prije nesreće',
        otherAreas: 'Ostala područja',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Je li osiguravatelj izdao potvrdu?',
        whetherTheAuthorityIssuesTheCertificate: 'Je li nadležno tijelo izdalo potvrdu?',
        isVDSReportAvailable: 'Je li VDS izvješće dostupno?',
        accidentProcess: 'Opis nesreće',
        accidentProcessPlaceholder:
            'Prema izjavi prijavitelja _XXXX.\n' +
            'Otprilike u XX:XX sati dana XX/XX/20XX, osoba XXXX je vozila vozilo s registracijom XXXXXX, model Roewe RX50 1.5/AT, sjeverno državnom cestom (u vozilu samo jedna osoba – vozač). Prilikom prolaska kroz dio XX u selu XX, grada XX, županije XX, primijetio je bijeli dim iz lijeve kabine.',
        accessoryMaterials: 'Prilozi',
        bulkDownload: 'Grupno preuzimanje',
        materialUpload: 'Učitavanje materijala',
        userReadmeAttachment: 'Prilog s opisom korisnika',
        sitePhotos: 'Fotografije mjesta',
        fireAccidentIdentificationLetter: 'Potvrda o požaru',
        insuranceRecordAttachment: 'Prilog osiguravajućeg zapisa',
        diagnosticRecords: 'Dijagnostički zapisi',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Odaberite vrstu prijave',
        fire_accident_identification_letter_required: 'Potvrda o požaru je obavezna',
        please_upload_the_fire_accident_identification_letter: 'Molimo učitajte potvrdu o požaru',
        insurance_record_attachment_required: 'Prilog osiguravajućeg zapisa je obavezan',
        please_upload_the_insurance_record_attachment:
            'Molimo učitajte prilog osiguravajućeg zapisa',
        please_upload_the_diagnostic_record_attachment:
            'Molimo učitajte prilog dijagnostičkog zapisa',
        please_upload_site_photos: 'Molimo učitajte fotografije mjesta',
    },

    // 拉脱维亚语
    lvLV: {
        documentType: 'Dokumenta veids',
        vehicleType: 'Transportlīdzekļa veids',
        dealerInformation: 'Izplatītāja informācija',
        reportType: 'Ziņošanas veids',
        dealerContact: 'Izplatītāja kontaktpersona',
        contact: 'Kontakttālrunis',
        customer_information: 'Klienta informācija',
        occupation: 'Profesija',
        vehicleInformation: 'Transportlīdzekļa informācija',
        mileage: 'Nobraukums (km)',
        licensePlate: 'Auto numurs',
        platform: 'Modeļa platforma',
        offLineDate: 'Izejas datums no līnijas',
        vehicleUse: 'Transportlīdzekļa pielietojums',
        refited: 'Vai ir veikti papildu pārbūves vai uzlabojumi?',
        insuranceSituation: 'Apdrošināšanas situācija',
        nameplateNo: 'Plāksnes numurs',
        purchaseDate: 'Pirkšanas datums',
        accidentInformation: 'Negadījuma informācija',
        timeOfAccident: 'Negadījuma laiks',
        placeOfAccident: 'Negadījuma vieta',
        roadConditions: 'Ceļa apstākļi',
        pavementType: 'Seguma veids',
        weather: 'Laikapstākļi',
        vehicleCondition: 'Transportlīdzekļa stāvoklis',
        vehicleOfTheAccident: 'Transportlīdzekļa informācija negadījuma brīdī',
        vehicleCollisionPosition: 'Transportlīdzekļa sadursmes vieta',
        vehicleRunningStatus: 'Transportlīdzekļa braukšanas statuss',
        ownSpeed: 'Paša ātrums',
        vehicleSpeedOfTheOtherSide: 'Otras puses ātrums',
        personnelInsideTheVehicle: 'Personas transportlīdzeklī negadījuma brīdī',
        numberOfPeopleInTheCar: 'Personu skaits auto',
        personalInjury: 'Personu ievainojumi',
        distributionOfPersonnelInTheVehicle: 'Ievainoto personu sēdvietas',
        descriptionOfPersonalInjury: 'Personu ievainojumu apraksts',
        airbagDeployment: 'Gaisa spilvenu izvēršanās',
        safetyBeltWearing: 'Drošības jostas lietošana',
        brakeBeforeTheAccident: 'Bremzēšana pirms negadījuma',
        turnBeforeTheIncident: 'Pagrieziens pirms incidenta',
        whenCorrosionOccurs: 'Kad rodas korozija?',
        parkingTimeHours: 'Novietošanas laiks (stundas)',
        parkingTimeMinutes: 'Novietošanas laiks (minūtes)',
        drivingHours: 'Braukšanas stundas',
        drivingMinutes: 'Braukšanas minūtes',
        drivingDistance: 'Braukšanas attālums',
        drivingSpeed: 'Braukšanas ātrums',
        vehicleState: 'Transportlīdzekļa stāvoklis negadījuma brīdī',
        fireFightingOrNot: 'Vai ugunsdzēsēji dzēsa uguni?',
        numberOfInjured: 'Ievainoto skaits',
        deathToll: 'Bojāgājušo skaits',
        vehicleHelp: 'Palīdzība transportlīdzeklim',
        vehiclePassingAccident: 'Iepriekšējie transportlīdzekļa negadījumi',
        pastAccidents: 'Iepriekšējie negadījumi',
        isTheWarningLampOnBeforeTheEvent: 'Vai brīdinājuma lampa dega pirms notikuma?',
        specificIconContent: 'Konkrētas ikonas saturs',
        didYouSmellFuelBeforeTheAccident: 'Vai sajutāt degvielas smaku pirms negadījuma?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Vai jutāt neparastas vibrācijas pirms negadījuma?',
        abnormalSoundZone: 'Neparastas skaņas zona',
        didYouHearAnyNoiseBeforeTheAccident: 'Vai dzirdējāt troksni pirms negadījuma?',
        noiseDescription: 'Troksnis aprakstīts',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Vieta, no kuras transports dūmoja pirms negadījuma',
        otherAreas: 'Citas zonas',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Vai apdrošinātājs izsniedzis apliecību?',
        whetherTheAuthorityIssuesTheCertificate: 'Vai iestāde izsniegusi apliecību?',
        isVDSReportAvailable: 'Vai VDS ziņojums ir pieejams?',
        accidentProcess: 'Notikuma apraksts',
        accidentProcessPlaceholder:
            'Pēc ziņotāja _XXXX vārdiem.\n' +
            'Apmēram plkst. XX:XX, XX/XX/20XX, persona XXXX vadīja transportlīdzekli ar numuru XXXXXX, modeli Roewe RX50 1.5/AT, virzoties pa valsts šoseju no dienvidiem uz ziemeļiem (transportlīdzeklī bija tikai viena persona – vadītājs). Nonākot līdz posmam XX ciemā XX, pilsētā XX, reģionā XX, viņš ievēroja baltu dūmu kreisajā vadītāja kabīnē.',
        accessoryMaterials: 'Pielikumi',
        bulkDownload: 'Masveida lejupielāde',
        materialUpload: 'Materiālu augšupielāde',
        userReadmeAttachment: 'Lietotāja apraksta pielikums',
        sitePhotos: 'Vietas fotogrāfijas',
        fireAccidentIdentificationLetter: 'Ugunsgrēka apstiprinājums',
        insuranceRecordAttachment: 'Apdrošināšanas ieraksta pielikums',
        diagnosticRecords: 'Diagnostikas ieraksti',
        temperature: 'Temperatūra',
        please_select_the_reporting_type: 'Lūdzu, izvēlieties ziņošanas veidu',
        fire_accident_identification_letter_required: 'Ugunsgrēka apstiprinājums ir obligāts',
        please_upload_the_fire_accident_identification_letter:
            'Lūdzu, augšupielādējiet ugunsgrēka apstiprinājumu',
        insurance_record_attachment_required: 'Apdrošināšanas ieraksta pielikums ir obligāts',
        please_upload_the_insurance_record_attachment:
            'Lūdzu, augšupielādējiet apdrošināšanas ieraksta pielikumu',
        please_upload_the_diagnostic_record_attachment:
            'Lūdzu, augšupielādējiet diagnostikas ieraksta pielikumu',
        please_upload_site_photos: 'Lūdzu, augšupielādējiet vietu fotogrāfijas',
    },

    // 立陶宛语
    ltLT: {
        documentType: 'Dokumento tipas',
        vehicleType: 'Transporto priemonės tipas',
        dealerInformation: 'Tiekėjo informacija',
        reportType: 'Pranešimo tipas',
        dealerContact: 'Tiekėjo kontaktinis asmuo',
        contact: 'Kontaktinis telefonas',
        customer_information: 'Kliento informacija',
        occupation: 'Profesija',
        vehicleInformation: 'Transporto priemonės informacija',
        mileage: 'Nuvažiuotas atstumas (km)',
        licensePlate: 'Valstybinis numeris',
        platform: 'Modelio platforma',
        offLineDate: 'Gamytos datos pabaiga',
        vehicleUse: 'Transporto priemonės paskirtis',
        refited: 'Ar buvo atlikti papildomi pakeitimai ar modifikacijos?',
        insuranceSituation: 'Draudimo situacija',
        nameplateNo: 'Plokštelės numeris',
        purchaseDate: 'Pirkimo data',
        accidentInformation: 'Įvykio informacija',
        timeOfAccident: 'Įvykio laikas',
        placeOfAccident: 'Įvykio vieta',
        roadConditions: 'Kelio būklė',
        pavementType: 'Dangos tipas',
        weather: 'Oras',
        vehicleCondition: 'Transporto priemonės būklė',
        vehicleOfTheAccident: 'Transporto priemonės informacija įvykio metu',
        vehicleCollisionPosition: 'Transporto priemonės susidūrimo vieta',
        vehicleRunningStatus: 'Transporto priemonės važiavimo būsena',
        ownSpeed: 'Savo greitis',
        vehicleSpeedOfTheOtherSide: 'Kitos pusės greitis',
        personnelInsideTheVehicle: 'Asmenys transporto priemonėje įvykio metu',
        numberOfPeopleInTheCar: 'Žmonių skaičius automobilyje',
        personalInjury: 'Asmenų sužeidimai',
        distributionOfPersonnelInTheVehicle: 'Sužeistų asmenų sėdimos vietos',
        descriptionOfPersonalInjury: 'Asmenų sužeidimų aprašymas',
        airbagDeployment: 'Oro pagalvių išsiskleidimas',
        safetyBeltWearing: 'Saugos diržų naudojimas',
        brakeBeforeTheAccident: 'Stabdymas prieš įvykį',
        turnBeforeTheIncident: 'Posūkis prieš įvykį',
        whenCorrosionOccurs: 'Kada atsiranda korozija?',
        parkingTimeHours: 'Stovėjimo laikas (valandomis)',
        parkingTimeMinutes: 'Stovėjimo laikas (minutėmis)',
        drivingHours: 'Vairavimo valandos',
        drivingMinutes: 'Vairavimo minutės',
        drivingDistance: 'Nuvažiuotas atstumas',
        drivingSpeed: 'Vairavimo greitis',
        vehicleState: 'Transporto priemonės būklė įvykio metu',
        fireFightingOrNot: 'Ar gelbėjimo tarnyba gesino gaisrą?',
        numberOfInjured: 'Sužeistųjų skaičius',
        deathToll: 'Žuvusiųjų skaičius',
        vehicleHelp: 'Pagalba transporto priemonei',
        vehiclePassingAccident: 'Ankstesni transporto priemonės įvykiai',
        pastAccidents: 'Ankstesni įvykiai',
        isTheWarningLampOnBeforeTheEvent: 'Ar įspėjamasis žibintas degė prieš įvykį?',
        specificIconContent: 'Konkrečios piktogramos turinys',
        didYouSmellFuelBeforeTheAccident: 'Ar pajutote kuro kvapą prieš įvykį?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Ar jautėte nenormalų virpesį prieš įvykį?',
        abnormalSoundZone: 'Nenormalaus garso zona',
        didYouHearAnyNoiseBeforeTheAccident: 'Ar girdėjote triukšmą prieš įvykį?',
        noiseDescription: 'Triukšmo aprašymas',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Vieta, iš kurios transporto priemonė rūko prieš įvykį',
        otherAreas: 'Kitos sritys',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Ar draudimo bendrovė išdavė pažymą?',
        whetherTheAuthorityIssuesTheCertificate: 'Ar kompetentinga institucija išdavė pažymą?',
        isVDSReportAvailable: 'Ar galima gauti VDS ataskaitą?',
        accidentProcess: 'Įvykio eiga',
        accidentProcessPlaceholder:
            'Pagal pranešėjo _XXXX žodžius.\n' +
            'Apie XX:XX val. XX/XX/20XX asmuo XXXX vairavo transporto priemonę su valstybiniu numeriu XXXXXX, modelis Roewe RX50 1.5/AT, važiuodamas nacionaliniu keliu iš pietų į šiaurę (transporto priemonėje buvo tik vienas asmuo – vairuotojas). Pasiekęs XX rajoną, XX miestelyje, XX mieste, XX srityje, pastebėjo baltą dūmą iš kairės vairuotojo kabinos.',
        accessoryMaterials: 'Priedai',
        bulkDownload: 'Masinis atsisiuntimas',
        materialUpload: 'Medžiagos įkėlimas',
        userReadmeAttachment: 'Naudotojo aprašymo priedas',
        sitePhotos: 'Vietos nuotraukos',
        fireAccidentIdentificationLetter: 'Gaisro įvykio patvirtinimas',
        insuranceRecordAttachment: 'Draudimo įrašo priedas',
        diagnosticRecords: 'Diagnostikos įrašai',
        temperature: 'Temperatūra',
        please_select_the_reporting_type: 'Pasirinkite pranešimo tipą',
        fire_accident_identification_letter_required: 'Gaisro įvykio patvirtinimas yra privalomas',
        please_upload_the_fire_accident_identification_letter:
            'Prašome įkelti gaisro įvykio patvirtinimą',
        insurance_record_attachment_required: 'Draudimo įrašo priedas yra privalomas',
        please_upload_the_insurance_record_attachment: 'Prašome įkelti draudimo įrašo priedą',
        please_upload_the_diagnostic_record_attachment: 'Prašome įkelti diagnostikos įrašo priedą',
        please_upload_site_photos: 'Prašome įkelti vietos nuotraukas',
    },

    // 罗马尼亚语
    roRO: {
        documentType: 'Tip document',
        vehicleType: 'Tip vehicul',
        dealerInformation: 'Informații dealer',
        reportType: 'Tip raportare',
        dealerContact: 'Persoană de contact dealer',
        contact: 'Telefon de contact',
        customer_information: 'Informații client',
        occupation: 'Ocupație',
        vehicleInformation: 'Informații vehicul',
        mileage: 'Kilometraj (km)',
        licensePlate: 'Număr înmatriculare',
        platform: 'Platformă model',
        offLineDate: 'Data ieșirii din fabricație',
        vehicleUse: 'Destinație vehicul',
        refited: 'Există modificări sau echipamente suplimentare?',
        insuranceSituation: 'Situație asigurare',
        nameplateNo: 'Număr placă identificare',
        purchaseDate: 'Data achiziției',
        accidentInformation: 'Informații accident',
        timeOfAccident: 'Data și ora accidentului',
        placeOfAccident: 'Locul accidentului',
        roadConditions: 'Condiții drum',
        pavementType: 'Tip carosabil',
        weather: 'Vreme',
        vehicleCondition: 'Stare vehicul',
        vehicleOfTheAccident: 'Informații vehicul în momentul accidentului',
        vehicleCollisionPosition: 'Poziție coliziune vehicul',
        vehicleRunningStatus: 'Stare de mers vehicul',
        ownSpeed: 'Viteză proprie',
        vehicleSpeedOfTheOtherSide: 'Viteză partea cealaltă',
        personnelInsideTheVehicle: 'Persoane în vehicul în momentul accidentului',
        numberOfPeopleInTheCar: 'Număr persoane în mașină',
        personalInjury: 'Leziuni corporale',
        distributionOfPersonnelInTheVehicle: 'Poziții persoane accidentate',
        descriptionOfPersonalInjury: 'Descriere leziuni',
        airbagDeployment: 'Activare airbag',
        safetyBeltWearing: 'Purtare centură siguranță',
        brakeBeforeTheAccident: 'Frânare înainte de accident',
        turnBeforeTheIncident: 'Viraj înainte de incident',
        whenCorrosionOccurs: 'Când apare coroziunea?',
        parkingTimeHours: 'Timp parcare (ore)',
        parkingTimeMinutes: 'Timp parcare (minute)',
        drivingHours: 'Ore condus',
        drivingMinutes: 'Minute condus',
        drivingDistance: 'Distanță parcursă',
        drivingSpeed: 'Viteză de condus',
        vehicleState: 'Stare vehicul în momentul accidentului',
        fireFightingOrNot: 'Intervenție pompieri?',
        numberOfInjured: 'Număr răniți',
        deathToll: 'Număr decese',
        vehicleHelp: 'Ajutor pentru vehicul',
        vehiclePassingAccident: 'Accidente anterioare ale vehiculului',
        pastAccidents: 'Accidente anterioare',
        isTheWarningLampOnBeforeTheEvent: 'Era martorul de avertizare activ înainte de eveniment?',
        specificIconContent: 'Conținut pictogramă specifică',
        didYouSmellFuelBeforeTheAccident: 'Ați simțit miros de combustibil înainte de accident?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Ați simțit vibrații anormale înainte de accident?',
        abnormalSoundZone: 'Zonă cu zgomote anormale',
        didYouHearAnyNoiseBeforeTheAccident: 'Ați auzit zgomote înainte de accident?',
        noiseDescription: 'Descriere zgomot',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Zona din care vehiculul a început să fumeze înainte de accident',
        otherAreas: 'Alte zone',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'A emis compania de asigurări un certificat?',
        whetherTheAuthorityIssuesTheCertificate: 'A emis autoritatea competentă un certificat?',
        isVDSReportAvailable: 'Este disponibil raportul VDS?',
        accidentProcess: 'Desfășurarea evenimentului',
        accidentProcessPlaceholder:
            'Conform relatării raportorului _XXXX.\n' +
            'În jurul orei XX:XX, pe data de XX/XX/20XX, persoana XXXX conducea un vehicul cu nr. de înmatriculare XXXXXX, model Roewe RX50 1.5/AT, pe DN spre nord (în mașină era o singură persoană – șoferul). La intrarea în zona XX, comuna XX, orașul XX, județul XX, a observat fum alb în cabina șoferului stânga.',
        accessoryMaterials: 'Materiale atașate',
        bulkDownload: 'Descărcare în masă',
        materialUpload: 'Încărcare materiale',
        userReadmeAttachment: 'Atașament descriere utilizator',
        sitePhotos: 'Fotografii de la fața locului',
        fireAccidentIdentificationLetter: 'Certificat incendiu',
        insuranceRecordAttachment: 'Atașament înregistrare asigurare',
        diagnosticRecords: 'Înregistrări diagnostice',
        temperature: 'Temperatură',
        please_select_the_reporting_type: 'Selectați tipul de raportare',
        fire_accident_identification_letter_required: 'Certificatul de incendiu este obligatoriu',
        please_upload_the_fire_accident_identification_letter:
            'Vă rugăm încărcați certificatul de incendiu',
        insurance_record_attachment_required:
            'Atașamentul înregistrării asigurării este obligatoriu',
        please_upload_the_insurance_record_attachment:
            'Vă rugăm încărcați atașamentul înregistrării asigurării',
        please_upload_the_diagnostic_record_attachment:
            'Vă rugăm încărcați atașamentul înregistrărilor diagnostice',
        please_upload_site_photos: 'Vă rugăm încărcați fotografiile de la fața locului',
    },

    // 挪威博克马尔语
    nbNO: {
        documentType: 'Dokumenttype',
        vehicleType: 'Kjøretøytype',
        dealerInformation: 'Forhandlerinformasjon',
        reportType: 'Rapporttype',
        dealerContact: 'Kontaktperson hos forhandler',
        contact: 'Kontakttelefon',
        customer_information: 'Kundeinformasjon',
        occupation: 'Yrke',
        vehicleInformation: 'Kjøretøyinformasjon',
        mileage: 'Kjørelengde (km)',
        licensePlate: 'Registreringsnummer',
        platform: 'Modellplattform',
        offLineDate: 'Produksjonsavslutningsdato',
        vehicleUse: 'Kjøretøyets bruk',
        refited: 'Er det gjort ettermontering eller endringer?',
        insuranceSituation: 'Forsikringssituasjon',
        nameplateNo: 'Merkeplatenummer',
        purchaseDate: 'Kjøpsdato',
        accidentInformation: 'Ulykkesinformasjon',
        timeOfAccident: 'Tidspunkt for ulykken',
        placeOfAccident: 'Sted for ulykken',
        roadConditions: 'Veiens tilstand',
        pavementType: 'Veidekke',
        weather: 'Vær',
        vehicleCondition: 'Kjøretøyets tilstand',
        vehicleOfTheAccident: 'Kjøretøyinformasjon ved ulykken',
        vehicleCollisionPosition: 'Kollisjonssted på kjøretøyet',
        vehicleRunningStatus: 'Kjøretøyets kjørestatus',
        ownSpeed: 'Egen hastighet',
        vehicleSpeedOfTheOtherSide: 'Motpartens hastighet',
        personnelInsideTheVehicle: 'Personer i kjøretøyet ved ulykken',
        numberOfPeopleInTheCar: 'Antall personer i bilen',
        personalInjury: 'Personskader',
        distributionOfPersonnelInTheVehicle: 'Plassering av skadde personer',
        descriptionOfPersonalInjury: 'Beskrivelse av personskader',
        airbagDeployment: 'Luftputeutløsning',
        safetyBeltWearing: 'Bruk av sikkerhetssele',
        brakeBeforeTheAccident: 'Bremsing før ulykken',
        turnBeforeTheIncident: 'Sving før hendelsen',
        whenCorrosionOccurs: 'Når oppstår korrosjon?',
        parkingTimeHours: 'Parkeringsvarighet (timer)',
        parkingTimeMinutes: 'Parkeringsvarighet (minutter)',
        drivingHours: 'Kjøretimer',
        drivingMinutes: 'Kjøreminutter',
        drivingDistance: 'Kjøredistanse',
        drivingSpeed: 'Kjørehastighet',
        vehicleState: 'Kjøretøyets tilstand ved ulykken',
        fireFightingOrNot: 'Brannvesenet involvert?',
        numberOfInjured: 'Antall skadde',
        deathToll: 'Antall døde',
        vehicleHelp: 'Kjøretøyhjelp',
        vehiclePassingAccident: 'Tidligere ulykker med kjøretøyet',
        pastAccidents: 'Tidligere ulykker',
        isTheWarningLampOnBeforeTheEvent: 'Varsellys på før hendelsen?',
        specificIconContent: 'Spesifikt ikoninnhold',
        didYouSmellFuelBeforeTheAccident: 'Luktet du drivstoff før ulykken?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Opplevde du unormal vibrasjon før ulykken?',
        abnormalSoundZone: 'Område med unormal lyd',
        didYouHearAnyNoiseBeforeTheAccident: 'Hørte du støy før ulykken?',
        noiseDescription: 'Beskrivelse av støy',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Område hvor kjøretøyet røyket før ulykken',
        otherAreas: 'Andre områder',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Har forsikringsselskapet utstedt attest?',
        whetherTheAuthorityIssuesTheCertificate: 'Har myndighet utstedt attest?',
        isVDSReportAvailable: 'Er VDS-rapport tilgjengelig?',
        accidentProcess: 'Hendelsesforløp',
        accidentProcessPlaceholder:
            'Ifølge rapportør _XXXX.\n' +
            'Rundt klokken XX:XX den XX/XX/20XX kjørte personen XXXX et kjøretøy med registreringsnummer XXXXXX, modell Roewe RX50 1.5/AT, nordover på riksvei (kun én person i bilen – føreren). Ved ankomst til strekningen ved tettstedet XX i kommune XX, fylke XX, merket han hvit røyk fra venstre førerkabinett.',
        accessoryMaterials: 'Vedlegg',
        bulkDownload: 'Massetnedlasting',
        materialUpload: 'Opplasting av materiale',
        userReadmeAttachment: 'Brukerbeskrivelse som vedlegg',
        sitePhotos: 'Stedsbilder',
        fireAccidentIdentificationLetter: 'Brannattest',
        insuranceRecordAttachment: 'Forsikringsjournal som vedlegg',
        diagnosticRecords: 'Diagnosejournaler',
        temperature: 'Temperatur',
        please_select_the_reporting_type: 'Velg rapporttype',
        fire_accident_identification_letter_required: 'Brannattest er påkrevd',
        please_upload_the_fire_accident_identification_letter: 'Last opp brannattesten',
        insurance_record_attachment_required: 'Forsikringsjournal er påkrevd',
        please_upload_the_insurance_record_attachment: 'Last opp forsikringsjournalen',
        please_upload_the_diagnostic_record_attachment: 'Last opp diagnosejournalen',
        please_upload_site_photos: 'Last opp stedsbilder',
    },

    // 葡萄牙语（巴西）
    ptBX: {
        documentType: 'Tipo de documento',
        vehicleType: 'Tipo de veículo',
        dealerInformation: 'Informações do concessionário',
        reportType: 'Tipo de relatório',
        dealerContact: 'Contato do concessionário',
        contact: 'Telefone de contato',
        customer_information: 'Informações do cliente',
        occupation: 'Profissão',
        vehicleInformation: 'Informações do veículo',
        mileage: 'Quilometragem (km)',
        licensePlate: 'Placa do veículo',
        platform: 'Plataforma do modelo',
        offLineDate: 'Data de saída da linha de produção',
        vehicleUse: 'Finalidade do veículo',
        refited: 'Houve instalação ou modificação adicional?',
        insuranceSituation: 'Situação do seguro',
        nameplateNo: 'Número da placa de identificação',
        purchaseDate: 'Data de compra',
        accidentInformation: 'Informações do acidente',
        timeOfAccident: 'Horário do acidente',
        placeOfAccident: 'Local do acidente',
        roadConditions: 'Condições da estrada',
        pavementType: 'Tipo de pavimento',
        weather: 'Clima',
        vehicleCondition: 'Condição do veículo',
        vehicleOfTheAccident: 'Informações do veículo no momento do acidente',
        vehicleCollisionPosition: 'Posição da colisão no veículo',
        vehicleRunningStatus: 'Estado de condução do veículo',
        ownSpeed: 'Velocidade própria',
        vehicleSpeedOfTheOtherSide: 'Velocidade do outro veículo',
        personnelInsideTheVehicle: 'Pessoas no veículo no momento do acidente',
        numberOfPeopleInTheCar: 'Número de pessoas no carro',
        personalInjury: 'Lesões pessoais',
        distributionOfPersonnelInTheVehicle: 'Posições dos feridos no veículo',
        descriptionOfPersonalInjury: 'Descrição das lesões',
        airbagDeployment: 'Acionamento do airbag',
        safetyBeltWearing: 'Uso do cinto de segurança',
        brakeBeforeTheAccident: 'Freou antes do acidente?',
        turnBeforeTheIncident: 'Virou antes do incidente?',
        whenCorrosionOccurs: 'Quando ocorre corrosão?',
        parkingTimeHours: 'Tempo estacionado (horas)',
        parkingTimeMinutes: 'Tempo estacionado (minutos)',
        drivingHours: 'Horas dirigindo',
        drivingMinutes: 'Minutos dirigindo',
        drivingDistance: 'Distância percorrida',
        drivingSpeed: 'Velocidade de condução',
        vehicleState: 'Estado do veículo no momento do acidente',
        fireFightingOrNot: 'Houve combate a incêndio pelos bombeiros?',
        numberOfInjured: 'Número de feridos',
        deathToll: 'Número de mortos',
        vehicleHelp: 'Solicitação de assistência ao veículo',
        vehiclePassingAccident: 'Acidentes anteriores do veículo',
        pastAccidents: 'Acidentes anteriores',
        isTheWarningLampOnBeforeTheEvent: 'A luz de aviso estava acesa antes do evento?',
        specificIconContent: 'Conteúdo do ícone específico',
        didYouSmellFuelBeforeTheAccident: 'Você sentiu cheiro de combustível antes do acidente?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Você sentiu vibração anormal antes do acidente?',
        abnormalSoundZone: 'Área com ruído anormal',
        didYouHearAnyNoiseBeforeTheAccident: 'Você ouviu algum barulho antes do acidente?',
        noiseDescription: 'Descrição do barulho',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Área onde o veículo começou a soltar fumaça antes do acidente',
        otherAreas: 'Outras áreas',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'A seguradora emitiu um certificado?',
        whetherTheAuthorityIssuesTheCertificate: 'A autoridade competente emitiu um certificado?',
        isVDSReportAvailable: 'O relatório VDS está disponível?',
        accidentProcess: 'Descrição do acidente',
        accidentProcessPlaceholder:
            'Relato do informante _XXXX.\n' +
            'Por volta das XX:XX do dia XX/XX/20XX, a pessoa XXXX dirigia um veículo com placa XXXXXX, modelo Roewe RX50 1.5/AT, pela rodovia sentido norte (apenas uma pessoa no carro – o motorista). Ao passar pelo trecho XX, município XX, cidade XX, estado XX, percebeu fumaça branca na cabine esquerda do motorista.',
        accessoryMaterials: 'Materiais anexos',
        bulkDownload: 'Download em lote',
        materialUpload: 'Envio de materiais',
        userReadmeAttachment: 'Anexo com descrição do usuário',
        sitePhotos: 'Fotos do local',
        fireAccidentIdentificationLetter: 'Laudo de incêndio',
        insuranceRecordAttachment: 'Anexo do registro do seguro',
        diagnosticRecords: 'Registros de diagnóstico',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Selecione o tipo de relatório',
        fire_accident_identification_letter_required: 'O laudo de incêndio é obrigatório',
        please_upload_the_fire_accident_identification_letter:
            'Por favor, envie o laudo de incêndio',
        insurance_record_attachment_required: 'O anexo do registro do seguro é obrigatório',
        please_upload_the_insurance_record_attachment:
            'Por favor, envie o anexo do registro do seguro',
        please_upload_the_diagnostic_record_attachment:
            'Por favor, envie o anexo dos registros de diagnóstico',
        please_upload_site_photos: 'Por favor, envie as fotos do local',
    },

    // 瑞典语
    svSE: {
        documentType: 'Dokumenttyp',
        vehicleType: 'Fordonstyp',
        dealerInformation: 'Återförsäljarinformation',
        reportType: 'Rapporttyp',
        dealerContact: 'Kontaktperson hos återförsäljare',
        contact: 'Kontakttelefon',
        customer_information: 'Kundinformation',
        occupation: 'Yrke',
        vehicleInformation: 'Fordonsinformation',
        mileage: 'Mätarställning (km)',
        licensePlate: 'Registreringsnummer',
        platform: 'Modellplattform',
        offLineDate: 'Datum för produktionsslut',
        vehicleUse: 'Fordonets användning',
        refited: 'Finns det eftermonterade delar eller modifieringar?',
        insuranceSituation: 'Försäkringssituation',
        nameplateNo: 'Typskyltens nummer',
        purchaseDate: 'Inköpsdatum',
        accidentInformation: 'Olycksfallsinformation',
        timeOfAccident: 'Tidpunkt för olyckan',
        placeOfAccident: 'Plats för olyckan',
        roadConditions: 'Vägförhållanden',
        pavementType: 'Vägbeläggning',
        weather: 'Väder',
        vehicleCondition: 'Fordonsstatus',
        vehicleOfTheAccident: 'Fordonsinformation vid olyckan',
        vehicleCollisionPosition: 'Krockposition på fordonet',
        vehicleRunningStatus: 'Fordonskörstatus',
        ownSpeed: 'Egen hastighet',
        vehicleSpeedOfTheOtherSide: 'Motpartens hastighet',
        personnelInsideTheVehicle: 'Personer i fordonet vid olyckan',
        numberOfPeopleInTheCar: 'Antal personer i bilen',
        personalInjury: 'Personskador',
        distributionOfPersonnelInTheVehicle: 'Positioner för skadade personer',
        descriptionOfPersonalInjury: 'Beskrivning av personskador',
        airbagDeployment: 'Krockkuddsaktivisering',
        safetyBeltWearing: 'Säkerhetsbälte använt',
        brakeBeforeTheAccident: 'Bromsning före olyckan',
        turnBeforeTheIncident: 'Sväng före händelsen',
        whenCorrosionOccurs: 'När uppstår korrosion?',
        parkingTimeHours: 'Parkeringsvaraktighet (timmar)',
        parkingTimeMinutes: 'Parkeringsvaraktighet (minuter)',
        drivingHours: 'Körtid (timmar)',
        drivingMinutes: 'Körtid (minuter)',
        drivingDistance: 'Körd sträcka',
        drivingSpeed: 'Körhastighet',
        vehicleState: 'Fordonsstatus vid olyckan',
        fireFightingOrNot: 'Brandkåren inblandad?',
        numberOfInjured: 'Antal skadade',
        deathToll: 'Antal dödade',
        vehicleHelp: 'Fordonsassistans',
        vehiclePassingAccident: 'Tidigare olyckor med fordonet',
        pastAccidents: 'Tidigare olyckor',
        isTheWarningLampOnBeforeTheEvent: 'Varningslampa tänd före händelsen?',
        specificIconContent: 'Specifikt ikoninnehåll',
        didYouSmellFuelBeforeTheAccident: 'Luktade du bränsle före olyckan?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident: 'Kände du ovanlig vibration före olyckan?',
        abnormalSoundZone: 'Område med ovanligt ljud',
        didYouHearAnyNoiseBeforeTheAccident: 'Hörde du något buller före olyckan?',
        noiseDescription: 'Beskrivning av buller',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Område där fordonet började ryka före olyckan',
        otherAreas: 'Andra områden',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Har försäkringsbolaget utfärdat intyg?',
        whetherTheAuthorityIssuesTheCertificate: 'Har myndighet utfärdat intyg?',
        isVDSReportAvailable: 'Är VDS-rapport tillgänglig?',
        accidentProcess: 'Händelseförlopp',
        accidentProcessPlaceholder:
            'Enligt rapportör _XXXX.\n' +
            'Ungefär kl. XX:XX den XX/XX/20XX körde personen XXXX ett fordon med registreringsnummer XXXXXX, modell Roewe RX50 1.5/AT, norrut på riksväg (endast en person i bilen – föraren). Vid ankomst till sträckan vid byn XX i kommunen XX, län XX, noterade han vit rök från vänster förarkabin.',
        accessoryMaterials: 'Bilagor',
        bulkDownload: 'Massnedladdning',
        materialUpload: 'Uppladdning av material',
        userReadmeAttachment: 'Användarbeskrivning som bilaga',
        sitePhotos: 'Platsbilder',
        fireAccidentIdentificationLetter: 'Brandintyg',
        insuranceRecordAttachment: 'Försäkringsjournal som bilaga',
        diagnosticRecords: 'Diagnosjournaler',
        temperature: 'Temperatur',
        please_select_the_reporting_type: 'Välj rapporttyp',
        fire_accident_identification_letter_required: 'Brandintyg krävs',
        please_upload_the_fire_accident_identification_letter: 'Ladda upp brandintyget',
        insurance_record_attachment_required: 'Försäkringsjournal krävs',
        please_upload_the_insurance_record_attachment: 'Ladda upp försäkringsjournalen',
        please_upload_the_diagnostic_record_attachment: 'Ladda upp diagnosjournalen',
        please_upload_site_photos: 'Ladda upp platsbilder',
    },

    // 斯洛伐克语
    skSK: {
        documentType: 'Typ dokumentu',
        vehicleType: 'Typ vozidla',
        dealerInformation: 'Informácie o predajcovi',
        reportType: 'Typ hlásenia',
        dealerContact: 'Kontaktná osoba predajcu',
        contact: 'Kontaktné telefónne číslo',
        customer_information: 'Informácie o zákazníkovi',
        occupation: 'Povolanie',
        vehicleInformation: 'Informácie o vozidle',
        mileage: 'Najazdené kilometre (km)',
        licensePlate: 'ŠPZ',
        platform: 'Platforma modelu',
        offLineDate: 'Dátum ukončenia výroby',
        vehicleUse: 'Účel použitia vozidla',
        refited: 'Boli vykonané úpravy alebo doplnky?',
        insuranceSituation: 'Stav poistenia',
        nameplateNo: 'Číslo typového štítka',
        purchaseDate: 'Dátum nákupu',
        accidentInformation: 'Informácie o nehode',
        timeOfAccident: 'Čas nehody',
        placeOfAccident: 'Miesto nehody',
        roadConditions: 'Stav cesty',
        pavementType: 'Typ povrchu',
        weather: 'Počasie',
        vehicleCondition: 'Stav vozidla',
        vehicleOfTheAccident: 'Informácie o vozidle počas nehody',
        vehicleCollisionPosition: 'Miesto nárazu na vozidle',
        vehicleRunningStatus: 'Stav jazdy vozidla',
        ownSpeed: 'Vlastná rýchlosť',
        vehicleSpeedOfTheOtherSide: 'Rýchlosť druhej strany',
        personnelInsideTheVehicle: 'Osoby vo vozidle počas nehody',
        numberOfPeopleInTheCar: 'Počet osôb vo vozidle',
        personalInjury: 'Zranenia osôb',
        distributionOfPersonnelInTheVehicle: 'Pozície zranených osôb',
        descriptionOfPersonalInjury: 'Popis zranení',
        airbagDeployment: 'Aktivácia airbagu',
        safetyBeltWearing: 'Použitie bezpečnostného pásu',
        brakeBeforeTheAccident: 'Brzdenie pred nehodou',
        turnBeforeTheIncident: 'Otočenie pred incidentom',
        whenCorrosionOccurs: 'Kedy dochádza ku korózii?',
        parkingTimeHours: 'Čas parkovania (hodiny)',
        parkingTimeMinutes: 'Čas parkovania (minúty)',
        drivingHours: 'Hodiny jazdy',
        drivingMinutes: 'Minúty jazdy',
        drivingDistance: 'Prejdená vzdialenosť',
        drivingSpeed: 'Rýchlosť jazdy',
        vehicleState: 'Stav vozidla počas nehody',
        fireFightingOrNot: 'Zasahovala hasičská jednotka?',
        numberOfInjured: 'Počet zranených',
        deathToll: 'Počet obetí',
        vehicleHelp: 'Pomoc pre vozidlo',
        vehiclePassingAccident: 'Predchádzajúce nehody vozidla',
        pastAccidents: 'Predchádzajúce nehody',
        isTheWarningLampOnBeforeTheEvent: 'Bolo varovné svetlo zapnuté pred udalosťou?',
        specificIconContent: 'Obsah konkrétnej ikony',
        didYouSmellFuelBeforeTheAccident: 'Pocítili ste zápach paliva pred nehodou?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Cítili ste abnormálne vibrácie pred nehodou?',
        abnormalSoundZone: 'Oblasť so zvláštnym zvukom',
        didYouHearAnyNoiseBeforeTheAccident: 'Počuli ste hluk pred nehodou?',
        noiseDescription: 'Popis hluku',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Oblasť, odkiaľ vozidlo pred nehodou dymilo',
        otherAreas: 'Iné oblasti',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Vydala poisťovňa osvedčenie?',
        whetherTheAuthorityIssuesTheCertificate: 'Vydal úrad osvedčenie?',
        isVDSReportAvailable: 'Je k dispozícii VDS správa?',
        accidentProcess: 'Priebeh nehody',
        accidentProcessPlaceholder:
            'Podľa výpovede podávateľa _XXXX.\n' +
            'Približne o XX:XX hod. dňa XX/XX/20XX osoba XXXX riadila vozidlo so ŠPZ XXXXXX, model Roewe RX50 1.5/AT, smerom na sever po štátnej ceste (vo vozidle bola len jedna osoba – vodič). Pri prechode úsekom XX v obci XX, meste XX, kraji XX si všimol biely dym z ľavej vodičskej kabíny.',
        accessoryMaterials: 'Prílohy',
        bulkDownload: 'Hromadné sťahovanie',
        materialUpload: 'Nahratie materiálov',
        userReadmeAttachment: 'Príloha s popisom používateľa',
        sitePhotos: 'Fotografie miesta',
        fireAccidentIdentificationLetter: 'Osvedčenie o požiari',
        insuranceRecordAttachment: 'Príloha poisťovacej zmluvy',
        diagnosticRecords: 'Diagnostické záznamy',
        temperature: 'Teplota',
        please_select_the_reporting_type: 'Vyberte typ hlásenia',
        fire_accident_identification_letter_required: 'Osvedčenie o požiari je povinné',
        please_upload_the_fire_accident_identification_letter:
            'Nahrajte prosím osvedčenie o požiari',
        insurance_record_attachment_required: 'Príloha poisťovacej zmluvy je povinná',
        please_upload_the_insurance_record_attachment: 'Nahrajte prosím prílohu poisťovacej zmluvy',
        please_upload_the_diagnostic_record_attachment:
            'Nahrajte prosím prílohu diagnostických záznamov',
        please_upload_site_photos: 'Nahrajte prosím fotografie miesta',
    },

    // 斯洛文尼亚语
    slSI: {
        documentType: 'Vrsta dokumenta',
        vehicleType: 'Vrsta vozila',
        dealerInformation: 'Informacije o prodajalcu',
        reportType: 'Vrsta poročila',
        dealerContact: 'Kontaktna oseba prodajalca',
        contact: 'Kontaktni telefon',
        customer_information: 'Informacije o stranki',
        occupation: 'Poklic',
        vehicleInformation: 'Informacije o vozilu',
        mileage: 'Prevoženi kilometri (km)',
        licensePlate: 'Registrska tablica',
        platform: 'Platforma modela',
        offLineDate: 'Datum izhoda iz proizvodnje',
        vehicleUse: 'Namembnost vozila',
        refited: 'Ali so bile opravljene dodatne prilagoditve ali montaže?',
        insuranceSituation: 'Zavarovalno stanje',
        nameplateNo: 'Številka tipske tablice',
        purchaseDate: 'Datum nakupa',
        accidentInformation: 'Informacije o nesreči',
        timeOfAccident: 'Čas nesreče',
        placeOfAccident: 'Kraj nesreče',
        roadConditions: 'Stanje ceste',
        pavementType: 'Vrsta cestišča',
        weather: 'Vreme',
        vehicleCondition: 'Stanje vozila',
        vehicleOfTheAccident: 'Informacije o vozilu ob nesreči',
        vehicleCollisionPosition: 'Položaj trka na vozilu',
        vehicleRunningStatus: 'Stanje vožnje vozila',
        ownSpeed: 'Lastna hitrost',
        vehicleSpeedOfTheOtherSide: 'Hitrost druge strani',
        personnelInsideTheVehicle: 'Osebe v vozilu ob nesreči',
        numberOfPeopleInTheCar: 'Število oseb v avtu',
        personalInjury: 'Telesne poškodbe',
        distributionOfPersonnelInTheVehicle: 'Položaji poškodovanih oseb',
        descriptionOfPersonalInjury: 'Opis telesnih poškodb',
        airbagDeployment: 'Aktiviranje zračne blazine',
        safetyBeltWearing: 'Uporaba varnostnega pasu',
        brakeBeforeTheAccident: 'Zaviranje pred nesrečo',
        turnBeforeTheIncident: 'Smer pred dogodkom',
        whenCorrosionOccurs: 'Kdaj se pojavlja korozija?',
        parkingTimeHours: 'Čas parkiranja (ure)',
        parkingTimeMinutes: 'Čas parkiranja (minute)',
        drivingHours: 'Ure vožnje',
        drivingMinutes: 'Minute vožnje',
        drivingDistance: 'Prevožena razdalja',
        drivingSpeed: 'Hitrost vožnje',
        vehicleState: 'Stanje vozila ob nesreči',
        fireFightingOrNot: 'Je gasilsko reševanje potekalo?',
        numberOfInjured: 'Število poškodovanih',
        deathToll: 'Število mrtvih',
        vehicleHelp: 'Pomoč vozilu',
        vehiclePassingAccident: 'Prejšnje nesreče vozila',
        pastAccidents: 'Prejšnje nesreče',
        isTheWarningLampOnBeforeTheEvent: 'Je bila opozorilna lučka vklopljena pred dogodkom?',
        specificIconContent: 'Vsebina določene ikone',
        didYouSmellFuelBeforeTheAccident: 'Ste zaznali vonj goriva pred nesrečo?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Ste čutili nenavadne vibracije pred nesrečo?',
        abnormalSoundZone: 'Območje nenavadnih zvokov',
        didYouHearAnyNoiseBeforeTheAccident: 'Ste slišali kakšen hrup pred nesrečo?',
        noiseDescription: 'Opis hrupa',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Območje, od koder je vozilo kadilo pred nesrečo',
        otherAreas: 'Druga območja',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Je zavarovalnica izdala potrdilo?',
        whetherTheAuthorityIssuesTheCertificate: 'Je urad izdal potrdilo?',
        isVDSReportAvailable: 'Je na voljo VDS poročilo?',
        accidentProcess: 'Opis dogodka',
        accidentProcessPlaceholder:
            'Po poročanju prijavitelja _XXXX.\n' +
            'Okoli XX:XX dne XX/XX/20XX je oseba XXXX vozila vozilo z registrsko tablico XXXXXX, model Roewe RX50 1.5/AT, proti severu po državni cesti (v vozilu je bila le ena oseba – voznik). Ko je prispel do odseka XX v vasi XX, mestu XX, regiji XX, je opazil bel dim iz leve voznikove kabine.',
        accessoryMaterials: 'Priloge',
        bulkDownload: 'Skupno prenašanje',
        materialUpload: 'Nalaganje materialov',
        userReadmeAttachment: 'Priloga z opisom uporabnika',
        sitePhotos: 'Fotografije kraja',
        fireAccidentIdentificationLetter: 'Potrdilo o požaru',
        insuranceRecordAttachment: 'Priloga zavarovalnih zapisov',
        diagnosticRecords: 'Diagnostični zapisi',
        temperature: 'Temperatura',
        please_select_the_reporting_type: 'Izberite vrsto poročila',
        fire_accident_identification_letter_required: 'Potrdilo o požaru je obvezno',
        please_upload_the_fire_accident_identification_letter:
            'Prosimo, naložite potrdilo o požaru',
        insurance_record_attachment_required: 'Priloga zavarovalnih zapisov je obvezna',
        please_upload_the_insurance_record_attachment:
            'Prosimo, naložite prilogo zavarovalnih zapisov',
        please_upload_the_diagnostic_record_attachment:
            'Prosimo, naložite prilogo diagnostičnih zapisov',
        please_upload_site_photos: 'Prosimo, naložite fotografije kraja',
    },

    // 泰语
    thTH: {
        documentType: 'ประเภทเอกสาร',
        vehicleType: 'ประเภทรถ',
        dealerInformation: 'ข้อมูลผู้จำหน่าย',
        reportType: 'ประเภทการรายงาน',
        dealerContact: 'ผู้ติดต่อผู้จำหน่าย',
        contact: 'เบอร์โทรศัพท์ติดต่อ',
        customer_information: 'ข้อมูลลูกค้า',
        occupation: 'อาชีพ',
        vehicleInformation: 'ข้อมูลรถ',
        mileage: 'ระยะทางที่วิ่งแล้ว (กม.)',
        licensePlate: 'ทะเบียนรถ',
        platform: 'แพลตฟอร์มรุ่นรถ',
        offLineDate: 'วันที่ออกจากสายการผลิต',
        vehicleUse: 'วัตถุประสงค์การใช้รถ',
        refited: 'มีการดัดแปลงหรือติดตั้งเพิ่มเติมหรือไม่?',
        insuranceSituation: 'สถานะประกันภัย',
        nameplateNo: 'หมายเลขป้ายชื่อ',
        purchaseDate: 'วันที่ซื้อ',
        accidentInformation: 'ข้อมูลอุบัติเหตุ',
        timeOfAccident: 'เวลาเกิดอุบัติเหตุ',
        placeOfAccident: 'สถานที่เกิดอุบัติเหตุ',
        roadConditions: 'สภาพถนน',
        pavementType: 'ประเภทผิวถนน',
        weather: 'สภาพอากาศ',
        vehicleCondition: 'สภาพรถ',
        vehicleOfTheAccident: 'ข้อมูลรถขณะเกิดอุบัติเหตุ',
        vehicleCollisionPosition: 'ตำแหน่งที่ชนของรถ',
        vehicleRunningStatus: 'สถานะการขับขี่ของรถ',
        ownSpeed: 'ความเร็วของตนเอง',
        vehicleSpeedOfTheOtherSide: 'ความเร็วของอีกฝ่าย',
        personnelInsideTheVehicle: 'ผู้โดยสารในรถขณะเกิดเหตุ',
        numberOfPeopleInTheCar: 'จำนวนคนในรถ',
        personalInjury: 'อาการบาดเจ็บของผู้โดยสาร',
        distributionOfPersonnelInTheVehicle: 'ตำแหน่งที่นั่งของผู้บาดเจ็บ',
        descriptionOfPersonalInjury: 'รายละเอียดอาการบาดเจ็บ',
        airbagDeployment: 'ถุงลมนิรภัยทำงานหรือไม่',
        safetyBeltWearing: 'คาดเข็มขัดนิรภัยหรือไม่',
        brakeBeforeTheAccident: 'เบรกก่อนเกิดอุบัติเหตุ',
        turnBeforeTheIncident: 'เลี้ยวก่อนเกิดเหตุ',
        whenCorrosionOccurs: 'เกิดสนิมเมื่อไหร่',
        parkingTimeHours: 'เวลาจอด (ชั่วโมง)',
        parkingTimeMinutes: 'เวลาจอด (นาที)',
        drivingHours: 'ชั่วโมงขับขี่',
        drivingMinutes: 'นาทีขับขี่',
        drivingDistance: 'ระยะทางขับขี่',
        drivingSpeed: 'ความเร็วขณะขับขี่',
        vehicleState: 'สภาพรถขณะเกิดอุบัติเหตุ',
        fireFightingOrNot: 'มีการดับเพลิงโดยหน่วยดับเพลิงหรือไม่',
        numberOfInjured: 'จำนวนผู้บาดเจ็บ',
        deathToll: 'จำนวนผู้เสียชีวิต',
        vehicleHelp: 'ความช่วยเหลือที่ต้องการสำหรับรถ',
        vehiclePassingAccident: 'ประวัติอุบัติเหตุของรถคันนี้',
        pastAccidents: 'อุบัติเหตุที่ผ่านมา',
        isTheWarningLampOnBeforeTheEvent: 'ไฟเตือนแสดงก่อนเกิดเหตุหรือไม่',
        specificIconContent: 'ไอคอนเฉพาะที่แสดง',
        didYouSmellFuelBeforeTheAccident: 'ได้กลิ่นน้ำมันเชื้อเพลิงก่อนเกิดอุบัติเหตุหรือไม่',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'รู้สึกสั่นผิดปกติก่อนเกิดอุบัติเหตุหรือไม่',
        abnormalSoundZone: 'บริเวณที่มีเสียงผิดปกติ',
        didYouHearAnyNoiseBeforeTheAccident: 'ได้ยินเสียงแปลกๆ ก่อนเกิดอุบัติเหตุหรือไม่',
        noiseDescription: 'คำอธิบายเสียง',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'บริเวณที่รถเริ่มมีควันก่อนเกิดอุบัติเหตุ',
        otherAreas: 'บริเวณอื่นๆ',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'บริษัทประกันออกใบรับรองหรือไม่',
        whetherTheAuthorityIssuesTheCertificate: 'หน่วยงานที่เกี่ยวข้องออกใบรับรองหรือไม่',
        isVDSReportAvailable: 'สามารถขอรายงาน VDS ได้หรือไม่',
        accidentProcess: 'ลำดับเหตุการณ์',
        accidentProcessPlaceholder:
            'ตามคำบอกเล่าของผู้แจ้ง _XXXX\n' +
            'ประมาณเวลา XX:XX น. วันที่ XX/XX/20XX คุณ XXXX ขับรถทะเบียน XXXXXX รุ่น Roewe RX50 1.5/AT วิ่งบนถนนสายหลักจากใต้ไปเหนือ (มีผู้โดยสาร 1 คน คือผู้ขับ) เมื่อถึงบริเวณหมู่บ้าน XX อำเภอ XX จังหวัด XX พบควันขาวเกิดขึ้นในห้องโดยสารด้านซ้าย',
        accessoryMaterials: 'เอกสารแนบ',
        bulkDownload: 'ดาวน์โหลดทั้งหมด',
        materialUpload: 'อัปโหลดเอกสาร',
        userReadmeAttachment: 'เอกสารแนบที่ผู้ใช้ให้มา',
        sitePhotos: 'รูปถ่ายสถานที่เกิดเหตุ',
        fireAccidentIdentificationLetter: 'หนังสือรับรองอุบัติเหตุเพลิงไหม้',
        insuranceRecordAttachment: 'เอกสารแนบประวัติประกัน',
        diagnosticRecords: 'บันทึกการวินิจฉัย',
        temperature: 'อุณหภูมิ',
        please_select_the_reporting_type: 'กรุณาเลือกประเภทการรายงาน',
        fire_accident_identification_letter_required: 'ต้องแนบหนังสือรับรองอุบัติเหตุเพลิงไหม้',
        please_upload_the_fire_accident_identification_letter:
            'กรุณาอัปโหลดหนังสือรับรองอุบัติเหตุเพลิงไหม้',
        insurance_record_attachment_required: 'ต้องแนบเอกสารประวัติประกัน',
        please_upload_the_insurance_record_attachment: 'กรุณาอัปโหลดเอกสารประวัติประกัน',
        please_upload_the_diagnostic_record_attachment: 'กรุณาอัปโหลดบันทึกการวินิจฉัย',
        please_upload_site_photos: 'กรุณาอัปโหลดรูปถ่ายสถานที่เกิดเหตุ',
    },

    // 乌克兰语
    ukUA: {
        documentType: 'Тип документа',
        vehicleType: 'Тип транспортного засобу',
        dealerInformation: 'Інформація про дилера',
        reportType: 'Тип повідомлення',
        dealerContact: 'Контактна особа дилера',
        contact: 'Контактний телефон',
        customer_information: 'Інформація про клієнта',
        occupation: 'Професія',
        vehicleInformation: 'Інформація про транспортний засіб',
        mileage: 'Пробіг (км)',
        licensePlate: 'Номерний знак',
        platform: 'Платформа моделі',
        offLineDate: 'Дата зняття з виробництва',
        vehicleUse: 'Призначення транспортного засобу',
        refited: 'Чи були внесені зміни або додаткове обладнання?',
        insuranceSituation: 'Стан страхування',
        nameplateNo: 'Номер таблички',
        purchaseDate: 'Дата покупки',
        accidentInformation: 'Інформація про ДТП',
        timeOfAccident: 'Час ДТП',
        placeOfAccident: 'Місце ДТП',
        roadConditions: 'Стан дороги',
        pavementType: 'Тип покриття',
        weather: 'Погода',
        vehicleCondition: 'Стан транспортного засобу',
        vehicleOfTheAccident: 'Інформація про ТЗ під час ДТП',
        vehicleCollisionPosition: 'Місце зіткнення на ТЗ',
        vehicleRunningStatus: 'Стан руху ТЗ',
        ownSpeed: 'Власна швидкість',
        vehicleSpeedOfTheOtherSide: 'Швидкість іншого учасника',
        personnelInsideTheVehicle: 'Особи в ТЗ під час ДТП',
        numberOfPeopleInTheCar: 'Кількість осіб у машині',
        personalInjury: 'Травми осіб',
        distributionOfPersonnelInTheVehicle: 'Позиції постраждалих',
        descriptionOfPersonalInjury: 'Опис травм',
        airbagDeployment: 'Спрацювання подушок безпеки',
        safetyBeltWearing: 'Використання ременів безпеки',
        brakeBeforeTheAccident: 'Гальмування перед ДТП',
        turnBeforeTheIncident: 'Поворот перед подією',
        whenCorrosionOccurs: 'Коли виникає корозія?',
        parkingTimeHours: 'Час стоянки (години)',
        parkingTimeMinutes: 'Час стоянки (хвилини)',
        drivingHours: 'Години водіння',
        drivingMinutes: 'Хвилини водіння',
        drivingDistance: 'Відстань водіння',
        drivingSpeed: 'Швидкість водіння',
        vehicleState: 'Стан ТЗ під час ДТП',
        fireFightingOrNot: 'Чи гасили пожежу пожежники?',
        numberOfInjured: 'Кількість поранених',
        deathToll: 'Кількість загиблих',
        vehicleHelp: 'Допомога для ТЗ',
        vehiclePassingAccident: 'Попередні ДТП з цим ТЗ',
        pastAccidents: 'Попередні ДТП',
        isTheWarningLampOnBeforeTheEvent: 'Чи горіла контрольна лампочка перед подією?',
        specificIconContent: 'Зміст певної піктограми',
        didYouSmellFuelBeforeTheAccident: 'Чи відчували запах пального перед ДТП?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Чи відчували незвичайні вібрації перед ДТП?',
        abnormalSoundZone: 'Зона сторонніх звуків',
        didYouHearAnyNoiseBeforeTheAccident: 'Чи чули шум перед ДТП?',
        noiseDescription: 'Опис шуму',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Місце, з якого ТЗ почав димити перед ДТП',
        otherAreas: 'Інші зони',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'Чи видавала страхова компанія довідку?',
        whetherTheAuthorityIssuesTheCertificate: 'Чи видавав уповноважений орган довідку?',
        isVDSReportAvailable: 'Чи доступний звіт VDS?',
        accidentProcess: 'Хід події',
        accidentProcessPlaceholder:
            'За словами заявника _XXXX.\n' +
            'Близько XX:XX XX/XX/20XX особа XXXX керувала ТЗ з номером XXXXXX, модель Roewe RX50 1.5/AT, рухаючись автострадою з півдня на північ (у машині була одна особа — водій). Коли він доїхав до ділянки XX у селі XX, місті XX, області XX, помітив білий дим у лівій кабіні водія.',
        accessoryMaterials: 'Додаткові матеріали',
        bulkDownload: 'Масове завантаження',
        materialUpload: 'Завантаження матеріалів',
        userReadmeAttachment: 'Додаток із описом користувача',
        sitePhotos: 'Фото місця події',
        fireAccidentIdentificationLetter: 'Акт про пожежу',
        insuranceRecordAttachment: 'Додаток страхових записів',
        diagnosticRecords: 'Діагностичні записи',
        temperature: 'Температура',
        please_select_the_reporting_type: 'Будь ласка, оберіть тип повідомлення',
        fire_accident_identification_letter_required: 'Акт про пожежу є обов’язковим',
        please_upload_the_fire_accident_identification_letter:
            'Будь ласка, завантажте акт про пожежу',
        insurance_record_attachment_required: 'Додаток страхових записів є обов’язковим',
        please_upload_the_insurance_record_attachment:
            'Будь ласка, завантажте додаток страхових записів',
        please_upload_the_diagnostic_record_attachment:
            'Будь ласка, завантажте додаток діагностичних записів',
        please_upload_site_photos: 'Будь ласка, завантажте фото місця події',
    },

    // 希腊语
    elGR: {
        documentType: 'Τύπος εγγράφου',
        vehicleType: 'Τύπος οχήματος',
        dealerInformation: 'Πληροφορίες αντιπροσώπου',
        reportType: 'Τύπος αναφοράς',
        dealerContact: 'Επαφή αντιπροσώπου',
        contact: 'Τηλέφωνο επικοινωνίας',
        customer_information: 'Πληροφορίες πελάτη',
        occupation: 'Επάγγελμα',
        vehicleInformation: 'Πληροφορίες οχήματος',
        mileage: 'Χιλιομετρική απόσταση (χλμ)',
        licensePlate: 'Αριθμός κυκλοφορίας',
        platform: 'Πλατφόρμα μοντέλου',
        offLineDate: 'Ημερομηνία αποχώρησης από τη γραμμή παραγωγής',
        vehicleUse: 'Χρήση οχήματος',
        refited: 'Έχουν γίνει τροποποιήσεις ή προσθήκες;',
        insuranceSituation: 'Κατάσταση ασφάλισης',
        nameplateNo: 'Αριθμός πινακίδας',
        purchaseDate: 'Ημερομηνία αγοράς',
        accidentInformation: 'Πληροφορίες ατυχήματος',
        timeOfAccident: 'Ώρα ατυχήματος',
        placeOfAccident: 'Τόπος ατυχήματος',
        roadConditions: 'Συνθήκες δρόμου',
        pavementType: 'Τύπος οδοστρώματος',
        weather: 'Καιρός',
        vehicleCondition: 'Κατάσταση οχήματος',
        vehicleOfTheAccident: 'Πληροφορίες οχήματος κατά το ατύχημα',
        vehicleCollisionPosition: 'Θέση σύγκρουσης οχήματος',
        vehicleRunningStatus: 'Κατάσταση λειτουργίας οχήματος',
        ownSpeed: 'Δική σας ταχύτητα',
        vehicleSpeedOfTheOtherSide: 'Ταχύτητα της άλλης πλευράς',
        personnelInsideTheVehicle: 'Άτομα στο όχημα κατά το ατύχημα',
        numberOfPeopleInTheCar: 'Αριθμός ατόμων στο αυτοκίνητο',
        personalInjury: 'Τραυματισμοί',
        distributionOfPersonnelInTheVehicle: 'Θέσεις τραυματισμένων',
        descriptionOfPersonalInjury: 'Περιγραφή τραυματισμών',
        airbagDeployment: 'Ανάπτυξη αερόσακου',
        safetyBeltWearing: 'Χρήση ζώνης ασφαλείας',
        brakeBeforeTheAccident: 'Φρενάρισμα πριν το ατύχημα',
        turnBeforeTheIncident: 'Στροφή πριν το περιστατικό',
        whenCorrosionOccurs: 'Πότε εμφανίζεται διάβρωση;',
        parkingTimeHours: 'Χρόνος στάθμευσης (ώρες)',
        parkingTimeMinutes: 'Χρόνος στάθμευσης (λεπτά)',
        drivingHours: 'Ώρες οδήγησης',
        drivingMinutes: 'Λεπτά οδήγησης',
        drivingDistance: 'Απόσταση οδήγησης',
        drivingSpeed: 'Ταχύτητα οδήγησης',
        vehicleState: 'Κατάσταση οχήματος κατά το ατύχημα',
        fireFightingOrNot: 'Παρέμβαση πυροσβεστικής υπηρεσίας;',
        numberOfInjured: 'Αριθμός τραυματισμένων',
        deathToll: 'Αριθμός θανάτων',
        vehicleHelp: 'Βοήθεια για το όχημα',
        vehiclePassingAccident: 'Προηγούμενα ατυχήματα οχήματος',
        pastAccidents: 'Προηγούμενα ατυχήματα',
        isTheWarningLampOnBeforeTheEvent:
            'Ήταν αναμμένο το φανάρι προειδοποίησης πριν το περιστατικό;',
        specificIconContent: 'Περιεχόμενο συγκεκριμένου εικονιδίου',
        didYouSmellFuelBeforeTheAccident: 'Μύρισες καύσιμο πριν το ατύχημα;',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident: 'Ένιωσες ανώμαλη δόνηση πριν το ατύχημα;',
        abnormalSoundZone: 'Ζώνη ανώμαλου ήχου',
        didYouHearAnyNoiseBeforeTheAccident: 'Άκουσες θόρυβο πριν το ατύχημα;',
        noiseDescription: 'Περιγραφή θορύβου',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Περιοχή από όπου το όχημα άρχισε να καπνίζει πριν το ατύχημα',
        otherAreas: 'Άλλες περιοχές',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Έχει εκδώσει η ασφαλιστική εταιρεία πιστοποιητικό;',
        whetherTheAuthorityIssuesTheCertificate: 'Έχει εκδώσει αρμόδια αρχή πιστοποιητικό;',
        isVDSReportAvailable: 'Είναι διαθέσιμη η αναφορά VDS;',
        accidentProcess: 'Περιγραφή περιστατικού',
        accidentProcessPlaceholder:
            'Σύμφωνα με τον αναφέροντα _XXXX.\n' +
            'Περίπου στις XX:XX της XX/XX/20XX, το άτομο XXXX οδηγούσε όχημα με αριθμό κυκλοφορίας XXXXXX, μοντέλο Roewe RX50 1.5/AT, βόρεια στον εθνικό δρόμο (μόνο ένα άτομο στο αυτοκίνητο – ο οδηγός). Φτάνοντας στο τμήμα XX του χωριού XX, πόλης XX, νομού XX, παρατήρησε λευκό καπνό στην αριστερή καμπίνα οδηγού.',
        accessoryMaterials: 'Συνημμένα υλικά',
        bulkDownload: 'Μαζική λήψη',
        materialUpload: 'Ανέβασμα υλικού',
        userReadmeAttachment: 'Συνημμένο περιγραφής χρήστη',
        sitePhotos: 'Φωτογραφίες τοποθεσίας',
        fireAccidentIdentificationLetter: 'Πιστοποιητικό πυρκαγιάς',
        insuranceRecordAttachment: 'Συνημμένο ασφαλιστικών εγγραφών',
        diagnosticRecords: 'Διαγνωστικά αρχεία',
        temperature: 'Θερμοκρασία',
        please_select_the_reporting_type: 'Παρακαλούμε επιλέξτε τύπο αναφοράς',
        fire_accident_identification_letter_required:
            'Το πιστοποιητικό πυρκαγιάς είναι υποχρεωτικό',
        please_upload_the_fire_accident_identification_letter:
            'Παρακαλούμε ανεβάστε το πιστοποιητικό πυρκαγιάς',
        insurance_record_attachment_required:
            'Το συνημμένο ασφαλιστικών εγγραφών είναι υποχρεωτικό',
        please_upload_the_insurance_record_attachment:
            'Παρακαλούμε ανεβάστε το συνημμένο ασφαλιστικών εγγραφών',
        please_upload_the_diagnostic_record_attachment:
            'Παρακαλούμε ανεβάστε το συνημμένο διαγνωστικών αρχείων',
        please_upload_site_photos: 'Παρακαλούμε ανεβάστε φωτογραφίες τοποθεσίας',
    },
    // 爱沙尼亚 (et-EE)
    etEE: {
        documentType: 'Dokumendi tüüp',
        vehicleType: 'Sõiduki tüüp',
        dealerInformation: 'Edasimüüja teave',
        reportType: 'Teatamise tüüp',
        dealerContact: 'Edasimüüja kontaktisik',
        contact: 'Kontakttelefon',
        customer_information: 'Kliendi teave',
        occupation: 'Elukutse',
        vehicleInformation: 'Sõiduki teave',
        mileage: 'Läbitud vahemaa/km',
        licensePlate: 'Numbrimärk',
        platform: 'Mudeli platvorm',
        offLineDate: 'Tootmisest väljastamise kuupäev',
        vehicleUse: 'Sõiduki kasutusotstarve',
        refited: 'Kas on lisaseadmeid või ümberkorraldusi?',
        insuranceSituation: 'Kindlustusolukord',
        nameplateNo: 'Tunnusplaat (tootenumber)',
        purchaseDate: 'Ostukuupäev',
        accidentInformation: 'Õnnetuse teave',
        timeOfAccident: 'Õnnetuse toimumise aeg',
        placeOfAccident: 'Õnnetuse asukoht',
        roadConditions: 'Teelised tingimused',
        pavementType: 'Pinnase tüüp',
        weather: 'Ilm',
        vehicleCondition: 'Sõiduki seisund',
        vehicleOfTheAccident: 'Õnnetuse ajal sõiduki andmed',
        vehicleCollisionPosition: 'Põrke asukoht sõidukil',
        vehicleRunningStatus: 'Sõiduki liikumise olek',
        ownSpeed: 'Oma sõiduki kiirus',
        vehicleSpeedOfTheOtherSide: 'Teise osapoole sõiduki kiirus',
        personnelInsideTheVehicle: 'Sõidukis viibinud isikud õnnetuse ajal',
        numberOfPeopleInTheCar: 'Sõidukis olnud inimeste arv',
        personalInjury: 'Isikukahjustused',
        distributionOfPersonnelInTheVehicle: 'Vigastatud isikute istekoht sõidukis',
        descriptionOfPersonalInjury: 'Isikukahjustuste kirjeldus',
        airbagDeployment: 'Airbag’i lahtipääsemine',
        safetyBeltWearing: 'Turvavöö kandmine',
        brakeBeforeTheAccident: 'Pidurdamine enne õnnetust',
        turnBeforeTheIncident: 'Suunamuutus enne õnnetust',
        whenCorrosionOccurs: 'Millal korrosioon ilmnes',
        parkingTimeHours: 'Seisuaeg (tundi)',
        parkingTimeMinutes: 'Seisuaeg (minutit)',
        drivingHours: 'Sõiduaeg (tundi)',
        drivingMinutes: 'Sõiduaeg (minutit)',
        drivingDistance: 'Sõidetud vahemaa',
        drivingSpeed: 'Sõidukiiruse keskmine',
        vehicleState: 'Sõiduki olek õnnetuse ajal',
        fireFightingOrNot: 'Kas tuli kustutati tuletõrjujate poolt?',
        numberOfInjured: 'Vigastatute arv',
        deathToll: 'Hukkunute arv',
        vehicleHelp: 'Abipalve sõidukile',
        vehiclePassingAccident: 'Varasemad õnnetused selle sõidukiga',
        pastAccidents: 'Varasemad õnnetused',
        isTheWarningLampOnBeforeTheEvent: 'Kas hoiatuslamp põles enne sündmust?',
        specificIconContent: 'Konkreetse ikooni sisu',
        didYouSmellFuelBeforeTheAccident: 'Kas sa tundsid kütuse lõhna enne õnnetust?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Kas sa tundsid ebanormaalset vibratsiooni enne õnnetust?',
        abnormalSoundZone: 'Ebanormaalse heli allikas',
        didYouHearAnyNoiseBeforeTheAccident: 'Kas sa kuulsid mingit müra enne õnnetust?',
        noiseDescription: 'Müra kirjeldus',
        theAreaWhereTheVehicleSmokedBeforeTheAccident:
            'Piirkond, kust sõiduk suitsus enne õnnetust',
        otherAreas: 'Muud piirkonnad',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Kas kindlustusfirma on väljastanud tõendi?',
        whetherTheAuthorityIssuesTheCertificate: 'Kas ametiasutus on väljastanud tõendi?',
        isVDSReportAvailable: 'Kas VDS-raport on saadaval?',
        accidentProcess: 'Sündmuse kulgu',
        accidentProcessPlaceholder:
            'Esitaja _XXXX ümbersõnastus.\n' +
            'Umbes kell XX:XX öösel XX.XX.20XX juhtis isik XXXX numbrimärgiga XXXXXX sõidukit (Roewe RX50 1.5/AT) riigimaantee peal lõunast põhja suunas (sõidukis oli kokku üks inimene – juht). Kui ta jõudis XXX provintsis, XX linna, XX maakonna, XX küla lähedale, märkas ta juhiistme vasakult poolt valget suitsu.',
        accessoryMaterials: 'Manusematerjalid',
        bulkDownload: 'Massallalaadimine',
        materialUpload: 'Materjalide üleslaadimine',
        userReadmeAttachment: 'Kasutaja kirjelduse manused',
        sitePhotos: 'Kohapealsed fotod',
        fireAccidentIdentificationLetter: 'Tulekahju õnnetuse tuvastuskiri',
        insuranceRecordAttachment: 'Kindlustusregistri manused',
        diagnosticRecords: 'Diagnostikaregistriväljavõtted',
        temperature: 'Temperatuur',
        please_select_the_reporting_type: 'Palun vali teatamise tüüp',
        fire_accident_identification_letter_required:
            'Tulekahju õnnetuse tuvastuskiri on kohustuslik',
        please_upload_the_fire_accident_identification_letter:
            'Palun laadi üles tulekahju õnnetuse tuvastuskiri',
        insurance_record_attachment_required: 'Kindlustusregistri manused on kohustuslikud',
        please_upload_the_insurance_record_attachment:
            'Palun laadi üles kindlustusregistri manused',
        please_upload_the_diagnostic_record_attachment:
            'Palun laadi üles diagnostikaregistriväljavõte',
        please_upload_site_photos: 'Palun laadi üles kohapealsed fotod',
    },

    // 哈萨克 (kk-KZ)
    kkKZ: {
        documentType: 'Құжат түрі',
        vehicleType: 'Көлік түрі',
        dealerInformation: 'Дилер туралы ақпарат',
        reportType: 'Есеп беру түрі',
        dealerContact: 'Дилердің байланыс адамы',
        contact: 'Байланыс телефоны',
        customer_information: 'Тұтынушы туралы мәлімет',
        occupation: 'Мамандығы',
        vehicleInformation: 'Көлік туралы ақпарат',
        mileage: 'Жүрген жолы/км',
        licensePlate: 'Номер таңбасы',
        platform: 'Автокөлік платформасы',
        offLineDate: 'Шығарылған күні',
        vehicleUse: 'Көлікті пайдалану мақсаты',
        refited: 'Қосымша құрылғы немесе өзгертілген бе?',
        insuranceSituation: 'Сақтандыру жағдайы',
        nameplateNo: 'Идентификациялық нөмір (шифр)',
        purchaseDate: 'Сатып алу күні',
        accidentInformation: 'Апат туралы ақпарат',
        timeOfAccident: 'Апаттың болған уақыты',
        placeOfAccident: 'Апаттың болған орны',
        roadConditions: 'Жол жағдайы',
        pavementType: 'Жолдың түрі',
        weather: 'Ауа райы',
        vehicleCondition: 'Көліктің техникалық жағдайы',
        vehicleOfTheAccident: 'Апат кезіндегі көлік туралы мәлімет',
        vehicleCollisionPosition: 'Көліктің соғылыс орны',
        vehicleRunningStatus: 'Көліктің қозғалыс күйі',
        ownSpeed: 'Өзіңіздің көлігіңіздің жылдамдығы',
        vehicleSpeedOfTheOtherSide: 'Қарсылас көліктің жылдамдығы',
        personnelInsideTheVehicle: 'Апат кезіндегі көліктегі адамдар',
        numberOfPeopleInTheCar: 'Көліктегі адам саны',
        personalInjury: 'Адамдардың зақымдануы',
        distributionOfPersonnelInTheVehicle: 'Зақымданған адамдардың отырған орны',
        descriptionOfPersonalInjury: 'Адамдардың зақымдануын сипаттау',
        airbagDeployment: 'Ауа подушкиның ашылуы',
        safetyBeltWearing: 'Қауіпсіздік белбеуін кию',
        brakeBeforeTheAccident: 'Апаттан бұрын тежеу',
        turnBeforeTheIncident: 'Оқиға болғанға дейінгі бұрылыс',
        whenCorrosionOccurs: 'Коррозия қашан пайда болды',
        parkingTimeHours: 'Тұру уақыты (сағат)',
        parkingTimeMinutes: 'Тұру уақыты (минут)',
        drivingHours: 'Жүру уақыты (сағат)',
        drivingMinutes: 'Жүру уақыты (минут)',
        drivingDistance: 'Жүрілген қашықтық',
        drivingSpeed: 'Жүру жылдамдығы',
        vehicleState: 'Апат кезіндегі көліктің күйі',
        fireFightingOrNot: 'Өрт сөндіру қызметі шақырылды ма?',
        numberOfInjured: 'Зақымданғандар саны',
        deathToll: 'Қаза болғандар саны',
        vehicleHelp: 'Көлікке көмек сұрау',
        vehiclePassingAccident: 'Көліктің алдыңғы апаттары',
        pastAccidents: 'Алдыңғы апаттар',
        isTheWarningLampOnBeforeTheEvent: 'Оқиға болғанға дейін ескерту шамы жанып тұрды ма?',
        specificIconContent: 'Нақты белгінің мазмұны',
        didYouSmellFuelBeforeTheAccident: 'Апаттан бұрын отын иісін сездіңіз бе?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident:
            'Апаттан бұрын қалыпты емес дірілді сездіңіз бе?',
        abnormalSoundZone: 'Дыбыс шыққан аймақ',
        didYouHearAnyNoiseBeforeTheAccident: 'Апаттан бұрын қандай дауыс естідіңіз бе?',
        noiseDescription: 'Дыбысты сипаттау',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'Апаттан бұрын көліктен түтін шыққан орын',
        otherAreas: 'Басқа аймақтар',
        whetherTheInsuranceCompanyHasIssuedACertificate:
            'Сақтандыру компаниясы растау құжатын берді ме?',
        whetherTheAuthorityIssuesTheCertificate: 'Лауазымды орган растау құжатын берді ме?',
        isVDSReportAvailable: 'VDS есебін алуға болады ма?',
        accidentProcess: 'Оқиғаның барысы',
        accidentProcessPlaceholder:
            'Хабарлаушы _XXXX айтқанынша:\n' +
            '20XX жылдың XX айының XX күні сағат XX:XX шамасында XXXX жүргізуші XXXXXX нөмірлі Roewe RX50 1.5/AT автокөлігімен мемлекеттік жол бойымен оңтүстіктен солтүстікке қарай жүріп келді (көлікте бір адам – жүргізуші ғана болды). XXX провинциясы, XX қаласы, XX ауданы, XX ауылы маңына жеткенде, ол жүргізуші орынның сол жағынан ақ түтін шығып жатқанын байқады.',
        accessoryMaterials: 'Қосымша материалдар',
        bulkDownload: 'Бірден жүктеп алу',
        materialUpload: 'Материалдарды жүктеу',
        userReadmeAttachment: 'Пайдаланушының түсіндірмесі',
        sitePhotos: 'Орындағы фотосуреттер',
        fireAccidentIdentificationLetter: 'Өрт апатын растайтын құжат',
        insuranceRecordAttachment: 'Сақтандыру жазбаларының қосымшасы',
        diagnosticRecords: 'Диагностикалық жазбалар',
        temperature: 'Температура',
        please_select_the_reporting_type: 'Есеп беру түрін таңдаңыз',
        fire_accident_identification_letter_required: 'Өрт апатын растайтын құжат міндетті',
        please_upload_the_fire_accident_identification_letter:
            'Өтінеміз, өрт апатын растайтын құжатты жүктеп салыңыз',
        insurance_record_attachment_required: 'Сақтандыру жазбаларының қосымшасы міндетті',
        please_upload_the_insurance_record_attachment:
            'Өтінеміз, сақтандыру жазбаларының қосымшасын жүктеп салыңыз',
        please_upload_the_diagnostic_record_attachment:
            'Өтінеміз, диагностикалық жазбаны жүктеп салыңыз',
        please_upload_site_photos: 'Өтінеміз, орындағы фотосуреттерді жүктеп салыңыз',
    },

    // 希伯来 (he-IL)
    heIL: {
        documentType: 'סוג מסמך',
        vehicleType: 'סוג רכב',
        dealerInformation: 'פרטי הסוכנות',
        reportType: 'סוג דיווח',
        dealerContact: 'איש קשר בסוכנות',
        contact: 'טלפון ליצירת קשר',
        customer_information: 'פרטי הלקוח',
        occupation: 'עיסוק',
        vehicleInformation: 'פרטי הרכב',
        mileage: 'קילומטראז‘',
        licensePlate: 'מספר רישוי',
        platform: 'פלטפורמת הדגם',
        offLineDate: 'תאריך יציאה מקו הייצור',
        vehicleUse: 'ייעוד השימוש ברכב',
        refited: 'האם בוצעו שדרוגים או שינויים?',
        insuranceSituation: 'מצב הביטוח',
        nameplateNo: 'מספר לוחית יצרן',
        purchaseDate: 'תאריך רכישה',
        accidentInformation: 'פרטי התאונה',
        timeOfAccident: 'שעת התאונה',
        placeOfAccident: 'מקום התאונה',
        roadConditions: 'מצב הכביש',
        pavementType: 'סוג המרצף',
        weather: 'מזג האוויר',
        vehicleCondition: 'מצב הרכב',
        vehicleOfTheAccident: 'נתוני הרכב בעת התאונה',
        vehicleCollisionPosition: 'מיקום ההתנגשות ברכב',
        vehicleRunningStatus: 'מצב הנהיגה בעת התאונה',
        ownSpeed: 'מהירות הרכב שלנו',
        vehicleSpeedOfTheOtherSide: 'מהירות רכב הצד השני',
        personnelInsideTheVehicle: 'מצב הנוסעים ברכב בעת התאונה',
        numberOfPeopleInTheCar: 'מספר האנשים ברכב',
        personalInjury: 'פגיעות גופניות',
        distributionOfPersonnelInTheVehicle: 'מיקום הפצועים ברכב',
        descriptionOfPersonalInjury: 'תיאור הפגיעות הגופניות',
        airbagDeployment: 'התרחבות כריות האוויר',
        safetyBeltWearing: 'עטיית חגורת בטיחות',
        brakeBeforeTheAccident: 'בלימה לפני התאונה',
        turnBeforeTheIncident: 'סיבוב בהגה לפני התאונה',
        whenCorrosionOccurs: 'מתי החלה ההחלמה',
        parkingTimeHours: 'זמן חניה (שעות)',
        parkingTimeMinutes: 'זמן חניה (דקות)',
        drivingHours: 'שעות נהיגה',
        drivingMinutes: 'דקות נהיגה',
        drivingDistance: 'מרחק נסיעה',
        drivingSpeed: 'מהירות נסיעה',
        vehicleState: 'מצב הרכב בעת התאונה',
        fireFightingOrNot: 'האם כיבוי האש נעשה על ידי כבאים?',
        numberOfInjured: 'מספר הפצועים',
        deathToll: 'מספר ההרוגים',
        vehicleHelp: 'בקשת עזרה לרכב',
        vehiclePassingAccident: 'תאונות קודמות של הרכב',
        pastAccidents: 'תאונות קודמות',
        isTheWarningLampOnBeforeTheEvent: 'האם נורת האזהרה הייתה דולקת לפני האירוע?',
        specificIconContent: 'תוכן הסמל הספציפי',
        didYouSmellFuelBeforeTheAccident: 'האם ריחשתם ריח דלק לפני התאונה?',
        didYouFeelAnyAbnormalVibrationBeforeTheAccident: 'האם הורגשתם רטט חריג לפני התאונה?',
        abnormalSoundZone: 'אזור מקור הרעש',
        didYouHearAnyNoiseBeforeTheAccident: 'האם שמעתם רעש כלשהו לפני התאונה?',
        noiseDescription: 'תיאור הרעש',
        theAreaWhereTheVehicleSmokedBeforeTheAccident: 'איזור העשן ברכב לפני התאונה',
        otherAreas: 'אזורים נוספים',
        whetherTheInsuranceCompanyHasIssuedACertificate: 'האם חברת הביטוח הנפיקה אישור?',
        whetherTheAuthorityIssuesTheCertificate: 'האם גוף מוסמך הנפיק אישור?',
        isVDSReportAvailable: 'האם ניתן להשיג דוח VDS?',
        accidentProcess: 'תהליך האירוע',
        accidentProcessPlaceholder:
            'בסיפורו של המדווח _XXXX:\n' +
            'בערך ב-XX:XX לפנות בוקר בתאריך XX/XX/20XX, נהג السيد XXXX ברכב הרשוי מספר XXXXXX מדגם Roewe RX50 1.5/AT בכביש המהיר מכיוון דרום לצפון (רכב עם נוסע אחד בלבד – הנהג). בעת שהגיע לקטע במחוז XXX, בעיר XX, באזור הכפרי XX, שם הבחין בעשן לבן שנשרף מצד שמאל של תא הנהג.',
        accessoryMaterials: 'חומרים מצורפים',
        bulkDownload: 'הורדה קבוצתית',
        materialUpload: 'העלאת חומרים',
        userReadmeAttachment: 'קובץ תיאור המשתמש',
        sitePhotos: 'תמונות מהזירה',
        fireAccidentIdentificationLetter: 'מסמך זיהוי תאונת שריפה',
        insuranceRecordAttachment: 'מסמכי ביטוח מצורפים',
        diagnosticRecords: 'רשומות אבחון',
        temperature: 'טמפרטורה',
        please_select_the_reporting_type: 'אנא בחר סוג דיווח',
        fire_accident_identification_letter_required: 'מסמך זיהוי תאונת שריפה הוא שדה חובה',
        please_upload_the_fire_accident_identification_letter:
            'אנא העלה את מסמך זיהוי תאונת השריפה',
        insurance_record_attachment_required: 'מסמכי הביטוח הם שדה חובה',
        please_upload_the_insurance_record_attachment: 'אנא העלה את מסמכי הביטוח',
        please_upload_the_diagnostic_record_attachment: 'אנא העלה את רשומות האבחון',
        please_upload_site_photos: 'אנא העלה תמונות מהזירה',
    },
};
